<template>
  <div class="container my-2" id="telaPrincipal">
    <div
      :v-if="mensagemSucesso"
      v-for="(i, index) in mensagemSucesso"
      :key="`mensagem-de-sucesso-${index}`"
    >
      <p>
        <b-alert show variant="success" dismissible>{{ i }}</b-alert>
      </p>
    </div>

    <div
      :v-if="mensagemErro"
      v-for="(i, index) in mensagemErro"
      :key="`mensagem-de-erro-${index}`"
    >
      <p v-if="i.mensLink != null">
        <b-alert  show variant="danger" dismissible>
          <b-icon variant="danger" icon="x-circle-fill" />

          {{ i.mensInicio   }}    
          <a v-if="i.mensLink && (i.mensLink.includes('http') || i.mensLink.includes('www'))"
             :href="i.mensLink" 
             target="_blank">aqui
          </a>
          {{ i.mensFim }}
        </b-alert>
      </p>
      <p v-else> 
        <b-alert  show variant="danger" dismissible>
          <b-icon variant="danger" icon="x-circle-fill" />
          {{ mensagemErro[index]}}
        </b-alert>         
      </p>
    </div>
    <!-- sdm 4289130  Wagner - 09/04/2025 -->
    <div v-if="exibeAlerteIssqnEstimativa">
      <b-alert show variant="danger">
        <div>
          <b-icon variant="primary" />
          ALERTA - Existem débitos da pessoa jurídica não listados abaixo
          que somente podem ser visualizados por meio de acesso
          identificado por um responsável legal. Para visualizá-los,
          acesse o sistema por meio do Gov.br.
        </div>
      </b-alert>
    </div>
    <!-- fim sdm  -->     
    <!-- sdm 4909857  Wagner - 16/07/2026 -->
    <div v-if="acessoMinisterioPublico">  
      <b-alert show variant="warning">
        <div>
          <b-icon variant="primary" />
          ALERTA - Para Pessoa Física e Jurídica, a consulta fica restrita a lançamentos de débitos inscritos em Dívida Ativa.
        </div>
      </b-alert>
    </div>
    <!-- fim sdm  -->       
    <div v-if="mostrarMensagemDebitosInexistentes" class="pb-1">
      <p>
        <b-alert show variant="warning" dismissible>
          <b-icon variant="warning" icon="exclamation-diamond-fill" />
          Não existe(m) débito(s) para esta pesquisa. Solicite a CND (certidão
          negativa de débitos) clicando
          <a href="http://cndonline.siatu.pbh.gov.br/CNDOnline" target="_blank"
            >aqui</a
          >.
        </b-alert>
      </p>
    </div>
   
    <p></p>
    <div>
      <div style="text-align: center">
        <loading :active.sync="carregando" :is-full-page="true"></loading>
      </div>
      <div class="mt-0">
        <!-- ABA DADOS GERAIS -->
        <form @submit.prevent>
          <h2 class="title">Pesquisar débito(s)</h2>
          <b-card>
            <div v-if="origemAcesso === 'AD' || origemAcesso === 'GovBr'">
              <span
                class="title h5"
                v-b-tooltip.hover="{ variant: 'primary', placement: 'right' }"
                title="Pesquisar débitos por pessoa natural ou jurídica, inclusive coobrigados e sócios."
              >
                Dados do contribuinte
                <b-icon
                  variant="primary"
                  icon="info-circle-fill"
                  class="ml-2"
                />
              </span>

              <b-row class="mb-0 mt-3">
                <b-col sm="2" md="2" class="mr-3">  </b-col>
                <b-col sm="2" md="2" lg="1" align-self="center">
                  <label for="cpf" class="pb-3">CPF/CNPJ</label>
                </b-col>
                <b-col sm="3" md="3" class="ml-5" align-self="start">
                  <b-form-input  
                    id="cpfCnpj"
                    class="ml-0"
                    :disabled="habilitaDesabilitaCnpjCpf"
                    v-mask="['XXX.XXX.XXX-XX', 'XX.XXX.XXX/XXXX-##']"
                    style="text-transform: uppercase"
                    v-model="dadosContribuinte.cadastroNacional"
                    @keyup="validacaoCPFCNPJ()"
                  >
                  </b-form-input>
                  <small
                    :class="erroValidacaoCPFCNPJ"
                    class="ml-3 form-text"
                  >
                    {{ mensagemValidacaoCPFCNPJ }}
                  </small>
                </b-col>
              </b-row>
              <b-row class="mb-2 mt-3">
                <b-col sm="2" md="2" class="mr-3"> </b-col>
                <b-col sm="2" md="2" lg="1" align-self="center">
                  <label for="nomeContribuinte" class="pb-3">Nome</label>
                </b-col>
                <b-col sm="8" md="6" align-self="start">
                  <b-form-input
                    id="nomeContribuinte"
                    class="ml-5"
                    :disabled="true"
                    v-model="dadosContribuinte.nomeContribuinte"
                  >
                  </b-form-input>
                </b-col>
              </b-row>
            </div>

            <div v-if="exibirEmpresaRelacionada">
              <!-- Linha horizontal -->
              <b-row class="mb-3">
                <b-col cols="12">
                  <div class="linha-separadora"></div>
                </b-col>
              </b-row>    
                        
              <b-row class="mb-3">
                <b-col sm="2" md="2"> </b-col>
                <b-col cols="1" class="mr-4 ml-3" align-self="end">
                  <label for="CNPJEmpresa">CNPJ</label>
                </b-col>
                <b-col cols="3" class="ml-4" align-self="start">
                  <b-form-input id="CNPJEmpresa" disabled v-model="cnpj.valor">
                  </b-form-input>
                </b-col>
              </b-row>

              <b-row class="mb-4">
                <b-col sm="2" md="2" class="mr-2"></b-col>

                <b-col cols="1" class="ml-2" align-self="end">
                  <label 
                    for="NomeFantasia" 
                    class="mb-0">
                    Nome Fantasia
                  </label>
                </b-col>
                <b-col cols="6" class="ml-5 mr-0" align-self="start">
                  <b-form-input
                    id="NomeFantasia"
                    class="flex-fill"
                    disabled
                    v-model="cnpj.nome">
                  </b-form-input>
                </b-col>
              </b-row>
            </div>

            <div >
              <span
                class="title h5"
                v-b-tooltip.hover="{ variant: 'primary', placement: 'right' }"
                title="Utilize esta opção para selecionar o tipo de identificador para o qual está sendo
                      feita a consulta de débitos para emissão do DRAM."
              >
                Opções para visualizar débitos específicos
                <span v-if="origemAcesso === 'GovBr'">
                  referente ao contribuinte acima
                </span>
                <b-icon variant="primary" icon="info-circle-fill" class="ml-2" />
              </span>

              <b-row class="my-3 mb-2">
                <b-col sm="2" md="2"> </b-col>
                <b-col cols="1" class="mr-4 ml-3" align-self="end">
                  <label for="opcaoIdentificador" class="p-0 mb-0 ml-3">Opções</label>
                </b-col>
                <b-col sm="5" md="3">
                  <b-form-select
                    id="opcaoIdentificador"
                    class="ml-3 mb-0 mr-sm-2 mb-sm-0"
                    v-model="dadosContribuinte.tipoIdentificador"
                    :options="opcoesIdentificador"
                    @change="reinicializaIdentificador()"
                  >
                  </b-form-select>
                </b-col>
                <b-col sm="5" md="5" class="ml-1" v-if="dadosContribuinte.tipoIdentificador">
                    <b-input-group class="mt-0">
                      <b-form-input
                        id="identificador"
                        @keyup="preencheIdentificador()"
                        v-mask="mascaraIdentificador"
                        v-model="dadosContribuinte.identificador"
                        @keydown="validacaoIdentificador()"
                        :placeholder="placeHolderIdentificador"
                      >
                      </b-form-input>
                    </b-input-group>
                    <small
                      id="identificador"
                      class="form-text"
                      :class="erroValidacaoIdentificador"
                    >
                      {{ mensagemValidacaoIdentificador }}
                    </small>
                </b-col>
              </b-row>
            </div>

            <div v-if="origemAcesso !== 'AD' && origemAcesso !== 'GovBr'">
              <b-row class="my-4 mb-3">
                <b-col sm="4" md="2"> </b-col>
                <b-col sm="4" md="8">
                  <span class="font-weight-bold font-italic"> ATENÇÃO: </span>
                  <span class="ml-2">
                    pesquisa por CPF deverá ser feita pelo acesso identificado
                    na página inicial.
                  </span>
                </b-col>
              </b-row>
            </div>

            <b-row class="mb-0 mt-2 float-right">
              <b-col v-if="pesquisando">
                <b-button
                  variant="outline-secondary"
                  @click.prevent="() => limparCamposCnpjsRelacionados()"
                >
                  <!-- {{
                    pesquisando
                      ? "Pesquisar novamente"
                      : "Retornar"
                  }}  -->
                      Retornar
                </b-button>
              </b-col>  
    
              <b-col v-if="!pesquisando">
                <b-button  v-if="dadosContribuinte.tipoIdentificador || cnpj.valor.length > 0 || 
                                (origemAcesso === 'AD' && dadosContribuinte.cadastroNacional.length > 0)"
                  class="mr-3"
                  variant="outline-secondary"
                  @click.prevent="() => limparCamposCnpjsRelacionados()"
                >  
                  Retornar
                </b-button>
                  
                <b-button
                  variant="primary"
                  :disabled="desabilitaBtnPesquisar"
                  @click.prevent="() => pesquisar()"
                >
                  Pesquisar 
                </b-button>
              </b-col>            
            </b-row>
            <b-row></b-row>
      
            <div v-if="cnpjsRelacionadosTabela.length > 0">
              <tabelaListagemCNPJ
                v-if="mostrarListagemCnpj"
                :rows="cnpjsRelacionadosTabela"
                :forca-limpar-campos="forcaLimparCamposListagemCnpj"
                @update:selecionado="handleCnpjTabelaSelecionado"
                @update:listaCnpjRelacionados="handleListaCnpjRelacionados"
              />
            </div>
         
          </b-card>
        </form>
      </div>
      <!--  -->
      <div v-if="mostrarErroMuitosLancamentos && !carregando" class="my-1">
        <h2 class="title mt-5">Informações do contribuinte</h2>
        <b-card class="mb-5">
          <b-card class="bg-primary mx-5">
            <div style="text-align: center">
              <span class="text-white font-weight-bolder">
                {{ formatCPFCNPJ(informacaoContribuinte.cadastroNacional) }}
                : {{ informacaoContribuinte.nome }}</span
              >
            </div>
          </b-card>
        </b-card>

        <b-alert show variant="warning">
          <b-icon variant="warning" icon="exclamation-diamond-fill" />
          Quantidade de registros superior ao limite. Favor solicitar o DRAM
          pelo e-mail
          <a href="mailto:gecda@pbh.gov.br">gecda@pbh.gov.br</a>
        </b-alert>
      </div>
      <div
        v-if="
          mostrarDemaisInformacoes &&
          !mostrarErroMuitosLancamentos &&
          !carregando
        "
      >
        <!-- selecao de debitos -->
        <h2 class="title mt-5" v-if="mostrarSelecaoDebitos === true">
          Seleção de débitos
        </h2>
        <div
          :v-if="mensagemLancamentos"
          v-for="i in mensagemLancamentos"
          :key="i"
        >
          <p>
            <b-alert show variant="warning">
              <div>
                <b-icon variant="warning" icon="exclamation-diamond-fill" />
                {{ i }}
              </div>
            </b-alert>
          </p>
        </div>
        <div
          v-if="mostrarSelecaoDebitos === true && listaAgrupamentos.length >= 1"
        >
          <b-alert show variant="primary">
            <div>
              <b-icon variant="primary" icon="info-circle-fill" />
              Selecione abaixo os débitos para emissão
            </div>
          </b-alert>
        </div>

        <b-card v-if="mostrarSelecaoDebitos === true">
          <div>
            <tabelaAgrupamentos
              :items="listaNiveis"
              v-on:mostrarDebitosSelecionados="getDebitosSelecionados($event)"
            />
            <a id="ancora-selecao-debitos"></a>
            <b-row class="mr-2 float-right">
              <b-button
                variant="primary"
                :disabled="
                  orgaoCobranca.length === 0 ||
                  bloquearExibirLancamentos === true
                "
                @click.prevent="habilitaSelecaoDebitos()"
              >
                Exibir débitos
              </b-button>
            </b-row>
          </div>
        </b-card>

        <!-- exibir debitos -->
        <div
          v-if="bloquearExibirLancamentos === true || exibirDebitos === true"
        >
          <h2 class="title mt-5">Débitos</h2>
          <b-card class="mb-0">
            <tabelaDebitosGrupo
              responsive="xl"
              :items="lancamentos"
              :fields="cabecalhoLancamento"
              :selecionados="lancamentosSelecionados"
              :limparSelecao="reinicializarSelecao"
              :refazerAgrupamento="refazerAgrupamento"
              title="lancamentos"
              v-on:mostrarSelecionados="getSelecionados($event)"
            />

            <b-row class="mt-3 float-right">
              <b-button
                class="my-3 mr-2"
                variant="secondary"
                @click="retornaSelecaoDebitos()"
              >
                Refazer agrupamento
              </b-button>

              <div class="my-3 mr-3">
                <b-button
                  :disabled="lancamentosSelecionados.length <= 0"
                  @click.prevent="abrirModal('modal-confirmar-selecao')"
                >
                  Confirmar seleção
                </b-button>
                <!-- confirmar cancelamento    -->
                <b-modal
                  ref="modal-confirmar-selecao"
                  hide-footer
                  title="Confirma"
                  size="sm"
                  centered
                  modal-class="small-modal"
                >
                  <p class="my-1">
                    Tem certeza que deseja confirmar a seleção dos débitos ?
                  </p>
                  <b-button-group class="w-100 mt-3">
                    <b-button
                      @click="fecharModal('modal-confirmar-selecao')"
                      size="sm"
                      variant="outline-secondary"
                    >
                      Não
                    </b-button>
                    <b-button
                      size="sm"
                      class="ml-2"
                      variant="primary"
                      @click="verificaPerfilConcessaoDesconto()"
                    >
                      Sim
                    </b-button>
                  </b-button-group>
                </b-modal>
                <!-- fim - confirmar cancelamento   -->
              </div>
            </b-row>
          </b-card>
        </div>
        <!-- debitos selecionados-->
        <div v-if="exibirDebitosSelecionados === true">
          <h2 class="title mt-5">Débitos selecionados</h2>
          <b-card class="mb-5">
            <tabelaDebitosSelecionados
              responsive="xl"
              :items="debitosSelecionados"
              :fields="cabecalhoDebitosSelecionados"
            />

            <b-row class="mt-3 float-right">
              <b-button
                class="my-3 mr-4"
                variant="secondary"
                @click="fecharDebitosSelecionados()"
              >
                Fechar
              </b-button>
            </b-row>
          </b-card>
        </div>
        <!-- lançamentos selecionados -->
        <div v-if="verLancamentos === true">
          <h2 class="title mt-5">Seleção de Lançamentos</h2>
          <b-card class="mb-5">
            <b-row>
              <b-col lg="6" md="4">
                <span
                  class="title h5 mr-2"
                  v-b-tooltip.hover="{ variant: 'primary', placement: 'right' }"
                  title="Verificar os débitos selecionados para confirmação da modalidade de pagamento."
                >
                  Relação de débitos selecionados para emissão de DRAM
                  <b-icon
                    variant="primary"
                    icon="info-circle-fill"
                    class="ml-2"
                  />
                </span>
              </b-col>
              <b-col lg="3"> </b-col>
              <b-col lg="3">
                <b-button
                  class="my-2 mr-1 float-right"
                  variant="primary"
                  @click="selecionarNovosLanctos()"
                >
                  Selecionar novos débitos
                </b-button>
              </b-col>
            </b-row>
            <b-row class="mt-1 center">
              <b-col lg="4"> </b-col>
              <b-col lg="4">
                <b-button
                  variant="link"
                  @click.prevent="mostrarDebitosSelecionados()"
                >
                  <h5>
                    Ver débitos selecionados
                    <b-icon icon="search" aria-hidden="true"></b-icon>
                  </h5>
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </div> 
        <!-- sem encargos -->
        <div v-if="mostrarSemEncargosMoratorios === true">
          <h2 class="title mt-5">Concessão de desconto / Novo vencimento</h2>
          <b-card class="mb-0">
            <div
              :v-if="mensagemErroConcessaoDesconto"
              v-for="i in mensagemErroConcessaoDesconto"
              :key="i"
            >
              <p>
                <b-alert show variant="danger" dismissible>
                  <b-icon variant="danger" icon="x-circle-fill" />
                  {{ i }}
                </b-alert>
              </p>
            </div>
            <div>
              <span class="title h5">
                Informe o percentual de desconto para cada um dos encargos
                abaixo, se for o caso.
              </span>
              <div>
                <span style="font-size: 13px">Os campos com asterisco ( </span>
                <span
                  class="font-weight-bold"
                  style="font-size: 20px; color: red"
                  >*</span
                >
                <span style="font-size: 13px">
                  ) são de preenchimento obrigatório.</span
                >
              </div>
              <b-row class="mb-0 mt-3">
                <b-col sm="1" md="1"> </b-col>
                <b-col sm="1" md="1" lg="1" align-self="center">
                  <label for="juros" class="pb-3 ml-3 mt-1">Juros</label>
                </b-col>
                <b-col sm="2" md="2" class="ml-0 mr-0" align-self="start">
                  <b-form-input
                    v-model="juros"
                    @input="validaPercentualDigitado(juros, 1)"
                    @blur="verificaPercentual(juros, 'juros')"
                    @paste="preventPaste"
                    id="juros"
                  ></b-form-input>
                </b-col>
                <b-col sm="1" md="1" class="ml-0 mr-0 mt-2">
                  <span style="color: black">%</span>
                </b-col>
                <b-col sm="8" md="8"> </b-col>
              </b-row>
              <b-row class="mb-0 mt-1">
                <b-col sm="1" md="1"> </b-col>
                <b-col sm="1" md="1" lg="1" align-self="center">
                  <label for="multa" class="pb-3 ml-3 mt-1">Multa</label>
                </b-col>
                <b-col sm="2" md="2" class="ml-0 mr-0" align-self="start">
                  <b-form-input
                    v-model="multa"
                    @input="validaPercentualDigitado(multa, 2)"
                    @blur="verificaPercentual(multa, 'multa')"
                    @paste="preventPaste"
                    id="multa"
                  ></b-form-input>
                </b-col>
                <b-col sm="1" md="1" class="ml-0 mr-0 mt-2">
                  <span style="color: black">%</span>
                </b-col>
                <b-col sm="8" md="8"> </b-col>
              </b-row>
              <b-row class="mb-0 mt-1">
                <b-col sm="1" md="1"> </b-col>
                <b-col sm="1" md="1" lg="1" align-self="center">
                  <label for="correção" class="pb-3 ml-3 mt-1">Correção</label>
                </b-col>
                <b-col sm="2" md="2" class="ml-0 mr-0" align-self="start">
                  <b-form-input
                    v-model="correcao"
                    @input="validaPercentualDigitado(correcao, 3)"
                    @blur="verificaPercentual(correcao, 'correção')"
                    @paste="preventPaste"
                    id="correção"
                  ></b-form-input>
                </b-col>
                <b-col sm="1" md="1" class="ml-0 mr-0 mt-2">
                  <span style="color: black">%</span>
                </b-col>
                <b-col sm="8" md="8"> </b-col>
              </b-row>
              <b-row class="mb-0 mt-1">
                <b-col sm="1" md="1"> </b-col>
                <b-col sm="1" md="1" lg="1" align-self="center">
                  <label for="selic" class="pb-3 ml-3 mt-1">Selic</label>
                </b-col>
                <b-col sm="2" md="2" class="ml-0 mr-0" align-self="start">
                  <b-form-input
                    v-model="selic"
                    @input="validaPercentualDigitado(selic, 4)"
                    @blur="verificaPercentual(selic, 'selic')"
                    @paste="preventPaste"
                    id="selic"
                  ></b-form-input>
                </b-col>
                <b-col sm="1" md="1" class="ml-0 mr-0 mt-2">
                  <span style="color: black">%</span>
                </b-col>
                <b-col sm="8" md="8"> </b-col>
              </b-row>
              <b-row class="mb-0 mt-4">
                <b-col sm="1" md="1"> </b-col>
                <b-col sm="4" md="4" lg="4" align-self="start" class="mr-0">
                  <label for="selic" class="pb-3 ml-3 mt-1 mr-0"
                    >Informe a nova data de vencimento da DRAM
                    <i
                      class="ml-0 font-weight-bold"
                      style="color: red; font-size: 20px"
                    >
                      *
                    </i>
                  </label>
                </b-col>
                <b-col sm="2" md="2" class="ml-0 mr-0">
                  <b-form-input
                    id="inicio"
                    v-model="venctoConcessaoDesconto"
                    type="date"
                  ></b-form-input>
                </b-col>
                <b-col sm="5" md="5"> </b-col>
              </b-row>
              <b-row class="mb-0 mt-4">
                <b-col sm="1" md="1"> </b-col>
                <b-col sm="4" md="4" lg="4" align-self="start" class="mr-0">
                  <label for="selic" class="ml-3 mr-0"
                    >Informe o processo que originou a concessão do desconto
                    <i
                      class="ml-0 font-weight-bold"
                      style="color: red; font-size: 20px"
                    >
                      *
                    </i>
                  </label>
                </b-col>
                <b-col sm="3" md="3" class="ml-0 mr-0">
                  <b-form-input
                    id="processoDesconto"
                    type="search"
                    v-mask="['##.########/####.##', '##.########-##']"
                    v-model="processoConcessaoDesconto"
                    @keyup="consistenumeroProcesso(processoConcessaoDesconto)"
                  >
                  </b-form-input>
                  <small
                    id="Proc"
                    :class="erroValidacaoProcesso"
                    class="ml-3 form-text"
                  >
                    {{ mensagemValidacaoProcesso }}
                  </small>
                </b-col>
                <b-col sm="3" md="3"> </b-col>
              </b-row>
              <b-row class="mb-0 mt-4 float-right">
                <b-button
                  variant="secondary"
                  class="float-right"
                  @click="() => limparCamposConcessaoDesconto()"
                >
                  <span> Limpar </span>
                </b-button>
                <b-button
                  variant="primary"
                  class="ml-3 mr-3 float-right"
                  :disabled="liberaBtnConcessaoDesconto()"
                  @click.prevent="() => concedeDesconto()"
                >
                  Conceder desconto / Novo vencimento
                </b-button>
                <b-button
                  variant="success"
                  class="ml-0 mr-3 float-right"
                  :disabled="liberaBtnSemDesconto()"
                  @click.prevent="() => continuaSemDesconto()"
                >
                  Continuar sem desconto
                </b-button>
                <!-- posiciona pagina  -->
                <a id="#ancora-sem-encargos"></a>
              </b-row>
            </div>
          </b-card>
        </div>
        <!-- fim - sem encargos moratorios -->
        <!-- forma de pagamento -->
        <div v-if="exibirFormaPagamento === true">
          <h2 class="title mt-5">Selecione a forma de pagamento</h2>
          <div
            :v-if="mensagemSucessoFormaPagto"
            v-for="i in mensagemSucessoFormaPagto"
            :key="i"
          >
            <p>
              <b-alert show variant="success" dismissible>{{ i }}</b-alert>
            </p>
          </div>
          <div
            :v-if="mensagemErroFormaPagto"
            v-for="i in mensagemErroFormaPagto"
            :key="i"
          >
            <p>
              <b-alert show variant="danger" dismissible>
                <b-icon variant="danger" icon="x-circle-fill" />
                {{ i }}
              </b-alert>
            </p>
          </div>
          <b-card class="mb-3" id="formaPagto">
            <b-row class="mb-3 center">
              <b-col lg="4"> </b-col>
              <b-col lg="2">
                <b-button
                  class="botao mt-3"
                  variant="primary"
                  @click.prevent="pagarVista()"
                >
                  Pagamento integral ou parcial
                </b-button>
              </b-col>
              <b-col lg="2">
                <b-button
                  class="botao mt-3"
                  v-if="this.permiteParcelar === true"
                  variant="secondary"
                  :disabled="desabilitaBtnParcelar"
                  @click.prevent="parcelar()"
                >
                  Parcelar
                </b-button>
              </b-col>
              <a id="ancora-forma-de-pagamento"></a>
            </b-row>
          </b-card>
        </div>
      </div>
      <div class="mt-5" v-else>
        <div
          :v-if="mensagemLancamentos"
          v-for="i in mensagemLancamentos"
          :key="i"
        >
          <p>
            <b-alert show variant="warning">
              <b-icon variant="warning" icon="exclamation-diamond-fill" />
              {{ i }}
            </b-alert>
          </p>
        </div>
      </div>

      <!-- lista guias a vista-->
      <div v-if="exibirListaGuia === true">
        <h2 class="title mt-5">Relação de DRAM para pagamento à vista</h2>
        <div
          :v-if="mensagemAlertaFormaPagto"
          v-for="i in mensagemAlertaFormaPagto"
          :key="i"
        >
          <p>
            <b-alert show variant="danger" dismissible>
              <b-icon variant="danger" icon="x-circle-fill" />
              {{ i }}
            </b-alert>
          </p>
        </div>
        <a id="ancora-pagamento-vista"></a>
        <b-card class="mt-3">
          <tabelaGuiasVista :items="calculos" :fields="cabecalhoGuias" />
          <b-row class="mt-3 float-right" v-if="!permiteConcederDesconto">
            <b-button
              class="my-3 mr-4"
              variant="secondary"
              @click="fecharGuiasAVista()"
            >
              Retornar para opções de pagamento
            </b-button>
          </b-row>
        </b-card>
      </div>
      <!-- lista guias a vista -->

      <!-- lista guias parcelado -->
      <div v-if="exibirListaGuiaParcelar === true">
        <h2 class="title mt-5">Seleção de parcelas para cada tipo de DRAM</h2>
        <div v-if="exibeMensVariasOpcParc">
          <span>
            <b>ATENÇÃO:</b>
          </span>
          <span>
            <i>
              Para a seleção de lançamentos realizada serão gerados mais de um
              DRAM. Você deverá selecionar uma opção de pagamento para cada um
              deles.
            </i>
          </span>
        </div>
        <b-card class="mb-3" id="listaGuiaParc">
          <tabelaListaParcelamento
            :items="listaParcelamentosCalc"
            :selecionados="selecLanctosParctoTacito"
            :desabilitaOpcoes="bloqueiaOpcao"
            v-on:parcelamentoTacito="getSelecionados($event)"
          />
          <a id="#ancora-opcao-parcelamento"></a>
        </b-card>
      </div>
      <!-- lista guias parcelado -->

      <b-card class="mt-3" v-if="calculos.RESUMO_CALCULO">
        <div>
          <div class="d-flex justify-content-around mt-3">
            <b-button
              class="mt-2 botao"
              variant="primary"
              size="lg"
              :disabled="bloqueioEmissaoGuia"
              @click.prevent="abrirDialogPagamentoAVista()"
            >
              Pagamento integral ou parcial
            </b-button>

            <b-button
              class="mt-2 botao"
              style="width: 120px"
              variant="secondary"
              :disabled="bloqueioEmissaoGuia"
              @click.prevent="abrirDialogParcelamento()"
            >
              Parcelar
            </b-button>

            <b-button
              class="mt-2"
              variant="secondary"
              @click.stop="simularPagamento"
            >
              Simulação
            </b-button>
          </div>
        </div>
      </b-card>

      <!-- lista parcelamento  -->
      <b-card class="mt-3" v-if="exibirParcelamento">
        <div>
          <p>Selecione a DRAM a ser emitida:</p>
          <b-row
            v-for="(guia, index) in listaDramParcelamento"
            :key="index"
            class="text-center mb-2"
            align-v="center"
          >
            <b-col>
              <b-button
                :variant="
                  btnSelecionadosParcelamento.findIndex(
                    (e) => e.id === `${index}`
                  ) !== -1
                    ? 'danger'
                    : 'primary'
                "
                @click="guiaPagamentoAVista(guia.URLEMISSAO, index)"
              >
                {{ guia.DESCRICAO }}
                {{
                  btnSelecionadosParcelamento.findIndex(
                    (e) => e.id === `${index}`
                  ) !== -1
                    ? " ( ** " + guia.tipo + " emitida ** )"
                    : " ( Emitir " + guia.tipo + " )"
                }}
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-card>
      <!-- fim -->

      <b-modal
        ref="dialog-confirmar-selecao"
        hide-footer
        title="Confirmar"
        size="sm"
        modal-class="small-modal"
        centered
      >
        <p>
          Não foram selecionados todos os débitos do tipo "{{
            orgaoCobranca.DESCRICAO
          }}" para esta emissão. Você deseja prosseguir com esta seleção?
        </p>

        <b-button-group class="w-100">
          <b-button
            colspan="6"
            variant="outline-secondary "
            @click="fecharModal('dialog-confirmar-a-vista')"
            >Não</b-button
          >
          <b-button
            colspan="6"
            class="ml-3"
            variant="primary"
            @click="
              abrirModalPagamentoAVistaSeNecessario('modal-pagamento-a-vista')
            "
            >Sim</b-button
          >
        </b-button-group>
      </b-modal>

      <b-modal
        ref="modal-pagamento-a-vista"
        hide-footer
        title="Pagar à Vista"
        size="xl"
        modal-class="small-modal"
      >
        <div v-if="calculos.TLISTAURLGUIA">
          <p>Selecione a DRAM a ser emitida:</p>
          <b-row
            v-for="(guia, index) in calculos.TLISTAURLGUIA"
            :key="index"
            class="text-center"
            align-v="center"
          >
            <b-col>
              <b-button
                variant="primary"
                @click="guiaPagamentoAVista(guia.URLEMISSAO, index)"
              >
                {{ guia.DESCRICAO }}
              </b-button>
              <hr />
            </b-col>
          </b-row>
        </div>

        <div v-else>
          <b-alert show variant="danger">
            <b-icon variant="danger" icon="x-circle-fill" />
            Erro ao gerar os DRAMs para pagamento à vísta, favor verificar com o
            Administrator do sistema.</b-alert
          >
        </div>
      </b-modal>

      <b-modal
        ref="modal-confirmar-parcelamento"
        hide-footer
        title="Seleção de Parcelamentos"
        size="xl"
        modal-class="small-modal"
      >
        <div
          v-if="calculos.OPCOES_PARCTO_CESSAO || calculos.OPCOES_PARCTO_DEMAIS"
        >
          <p>
            Para o parcelamento deverão ser emitidas dois DRAM, uma para cada
            opção abaixo:
          </p>
          <b-row class="text-center" align-v="center">
            <b-col v-if="calculos.OPCOES_PARCTO_CESSAO">
              <b-button
                variant="primary"
                @click="abrirModalParcelamentoSeNecessario('cessao')"
              >
                DRAM de Lançamentos Cedidos
              </b-button>
            </b-col>

            <b-col v-if="calculos.OPCOES_PARCTO_DEMAIS">
              <b-button
                variant="primary"
                @click="abrirModalParcelamentoSeNecessario('demais')"
              >
                DRAM Demais Lançamentos
              </b-button>
            </b-col>
          </b-row>
        </div>

        <div v-else>
          <b-alert show variant="danger">
            <b-icon variant="danger" icon="x-circle-fill" />
            Erro ao gerar os DRAM para pagamento à vísta, favor verificar com o
            Administrator do sistema.</b-alert
          >
        </div>
      </b-modal>

      <b-modal
        ref="modal-selecao-parcelamento"
        hide-footer
        title="Seleção de Parcelamentos"
        size="xl"
        modal-class="small-modal"
      >
        <div v-if="this.opcoesParcto">
          <p>Selecione uma das opções:</p>

          <b-row
            v-for="opcao in opcoesParcto"
            :key="opcao"
            class="text-center"
            align-v="center"
          >
            <b-col>
              <b-button
                variant="primary"
                @click="abrirModalParcelamento(opcao)"
              >
                {{ opcao.DESCRICAO_GRUPO }}
              </b-button>
              <hr />
            </b-col>
          </b-row>
        </div>

        <div v-else>
          <b-alert show variant="danger">
            <b-icon variant="danger" icon="x-circle-fill" />
            Erro ao gerar os DRAM para pagamento à vísta, favor verificar com o
            Administrator do sistema.</b-alert
          >
        </div>
      </b-modal>

      <b-modal
        ref="modal-parcelamento"
        hide-footer
        title="Parcelamento"
        size="xl"
        @hide="limparCamposParcelamento()"
      >
        <div v-if="this.opcaoParctoSelecionada.LISTA_OPCAO_PARCTO">
          <p>Selecione abaixo uma das opções de parcelamento</p>
          <div class="mb-3">
            <h5>Opções de parcelamento</h5>
            <b-form-select
              id="opcoesParcelamentoInternas"
              v-model="escolhaOpcaoParcelamentoInterna"
              :options="listaOpcoesParcelamentoInternas"
            />
          </div>

          <h4 class="mt-5">Contato</h4>
          <b-row class="mb-3">
            <b-col sm="2" align-self="end">
              <label for="telefoneCelular">Telefone Celular</label>
            </b-col>
            <b-col sm="3" align-self="start">
              <b-form-input
                id="telefoneCelular"
                placeholder="(31)99999-9999"
                v-mask="['(##)#####-####']"
                v-model="informacaoParcelamento.telefone"
              >
              </b-form-input>
            </b-col>
          </b-row>

          <b-row class="mb-3">
            <b-col sm="2" align-self="end">
              <label for="email">Email</label>
            </b-col>
            <b-col sm="3" align-self="start">
              <b-form-input
                type="email"
                id="email"
                placeholder="exemplo@exemplo.com.br"
                v-model="informacaoParcelamento.email"
              >
              </b-form-input>
            </b-col>
          </b-row>

          <div class="float-right">
            <b-button
              variant="primary"
              :disabled="
                escolhaOpcaoParcelamentoInterna === '' ||
                (informacaoParcelamento.email.length < 6 &&
                  !informacaoParcelamento.email.includes('@') &&
                  informacaoParcelamento.telefone.length < 14)
              "
              @click.prevent="emitirGuiaParcelamento"
            >
              Emitir DRAM</b-button
            >
          </div>
        </div>
        <div v-else>
          <b-alert show variant="danger"
            ><b-icon variant="danger" icon="x-circle-fill" />Erro ao gerar os
            parcelamentos, favor verificar com o Administrator do
            sistema.</b-alert
          >
        </div>
      </b-modal>

      <b-modal
        ref="modal-EmissaoGuia"
        hide-footer
        title="Confirmar emissão de DRAMs"
        size="xl"
        @show="autenticarEmissao()"
        @hide="limparCamposEmissaoGuia()"
      >
        <div
          :v-if="mensagemEmissaoGuia"
          v-for="i in mensagemEmissaoGuia"
          :key="i"
        >
          <p>
            <b-alert show variant="danger" dismissible>
              <b-icon variant="danger" icon="x-circle-fill" />
              {{ i }}
            </b-alert>
          </p>
        </div>
        <div
          :v-if="mensagemEmissaoGuiaSucesso"
          v-for="i in mensagemEmissaoGuiaSucesso"
          :key="i"
        >
          <p>
            <b-alert show variant="success" dismissible>
              <b-icon variant="success" icon="check2" />
              {{ i }}
            </b-alert>
          </p>
        </div>

        <h5>Preencha os dados abaixo para confirmar a emissão</h5>

        <b-row class="my-3">
          <b-col sm="2" align-self="end">
            <label for="cadastroNacional">CPF/CNPJ</label
            ><span class="ml-1" style="color: red">*</span>
          </b-col>
          <b-col sm="3" align-self="start">
            <b-form-input
              id="cadastroNacional"
              v-mask="['###.###.###-##', '##.###.###/####-##']"
              v-model="informacoesEmissaoGuia.cpfCnpj"
              disabled="disabled"
            >
            </b-form-input>
          </b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col sm="2" align-self="end">
            <label for="razaoSocial">Nome/Razão Social</label>
          </b-col>
          <b-col sm="3" align-self="start">
            <b-form-input
              id="razaoSocial"
              disabled="disabled"
              v-model="informacoesEmissaoGuia.razaoSocial"
            >
            </b-form-input>
          </b-col>
        </b-row>

        <h5>Contato</h5>
        <b-row class="mb-3">
          <b-col sm="2" align-self="end">
            <label for="telefone">Telefone Celular</label>
          </b-col>
          <b-col sm="3" align-self="start">
            <b-form-input
              id="telefone"
              v-mask="['(##)####-####', '(##)#####-####']"
              placeholder="(31)99999-9999"
              v-model="informacoesEmissaoGuia.telefoneCelular"
            >
            </b-form-input>
          </b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col sm="2" align-self="end">
            <label for="email">Email</label>
          </b-col>
          <b-col sm="3" align-self="start">
            <b-form-input
              id="email"
              type="email"
              v-model="informacoesEmissaoGuia.email"
              placeholder="exemplo@exemplo.com.br"
            >
            </b-form-input>
          </b-col>
        </b-row>

        <b-card
          v-if="
            informacoesEmissaoGuia.telefoneEnviado ||
            informacoesEmissaoGuia.emailEnviado
          "
          class="bg-secondary mt-5 mb-3 w-50 mx-auto"
        >
          <div style="text-align: center">
            <span class="font-weight-bolder text-white">
              Preencha o código recebido para confirmar a emissão
            </span>
            <b-form-input
              id="cancelarParcelamento"
              v-model="informacoesEmissaoGuia.codigoEmissaoGuia"
            />
          </div>
        </b-card>

        <div
          v-if="
            informacoesEmissaoGuia.email && informacoesEmissaoGuia.emailEnviado
          "
        >
          <b-alert show style="background-color: rgb(163, 207, 222)">
            <b-icon variant="warning" icon="exclamation-diamond-fill" />
            Foi enviada uma mensagem para o e-mail
            {{ informacoesEmissaoGuia.email }} com um código de confirmação. É
            obrigatório o preenchimento para dar continuidade na emissão do
            parcelamento. Favor verificar se a mensagem foi recebida. Caso não
            receba verifique mensagens bloqueadas e spam.</b-alert
          >
        </div>

        <div
          v-if="
            informacoesEmissaoGuia.telefoneCelular &&
            informacoesEmissaoGuia.telefoneEnviado
          "
        >
          <b-alert show style="background-color: rgb(163, 207, 222)">
            <b-icon variant="warning" icon="exclamation-diamond-fill" />
            Foi enviada uma mensagem para o número
            {{ informacoesEmissaoGuia.telefoneCelular }} com um código de
            confirmação. É obrigatório o preenchimento para dar continuidade na
            emissão de DRAM para parcelamento. Favor verificar se a mensagem foi
            recebida. Caso não receba verifique mensagens bloqueadas e spam.
          </b-alert>
        </div>

        <b-row v-if="!mostrarConfirmacaoEmissaoGuia" class="float-right">
          <b-button
            variant="primary"
            class="mr-3"
            @click="enviarSMSEmissaoGuiaParcelamento()"
            :disabled="informacoesEmissaoGuia.telefoneCelular.length < 14"
          >
            Enviar SMS
          </b-button>

          <b-button
            variant="primary"
            class="mr-3"
            @click="enviarEmailEmissaoGuiaParcelamento()"
            :disabled="
              informacoesEmissaoGuia.email.length < 6 &&
              !informacoesEmissaoGuia.email.includes('@')
            "
          >
            Enviar E-mail
          </b-button>
        </b-row>

        <b-row v-else class="float-right">
          <b-button
            variant="secondary"
            class="mr-3"
            @click="enviarSMSEmissaoGuiaParcelamento()"
            :disabled="informacoesEmissaoGuia.telefoneCelular.length < 14"
          >
            Reenviar SMS
          </b-button>

          <b-button
            variant="secondary"
            class="mr-3"
            @click="enviarEmailEmissaoGuiaParcelamento()"
            :disabled="
              informacoesEmissaoGuia.email.length < 6 &&
              !informacoesEmissaoGuia.email.includes('@')
            "
            >Reenviar E-mail</b-button
          >

          <b-button
            variant="primary"
            class="mr-3"
            @click="finalizarEmissaoGuiaEmLista()"
            :disabled="informacoesEmissaoGuia.codigoEmissaoGuia.length <= 5"
          >
            Confirmar emissão
          </b-button>
        </b-row>
      </b-modal>

      <b-modal
        ref="dialog-aviso-parcelamento-itbi"  
        title="ATENÇÃO !"
        ok-only
        modal-class="small-modal"
        centered
      >
         <h4>O registro do imóvel em cartório exige a quitação integral do ITBI. 
          Caso opte pelo parcelamento, a certidão necessária para o registro 
          só será emitida após a liquidação total de todas as parcelas.</h4>
      </b-modal>

      <b-modal
        ref="dialog-confirmar-parcelamento"
        hide-footer
        title="Confirmação de parcelamento"
        size="xs"
        modal-class="small-modal"
        centered
      >
        <p>
          Não foram selecionados todos os débitos do tipo "{{
            orgaoCobranca.DESCRICAO
          }}" para esta emissão. Você deseja prosseguir com esta seleção?
        </p>

        <b-button-group class="w-100">
          <b-button
            colspan="6"
            variant="outline-secondary "
            @click="fecharModal('dialog-confirmar-parcelamento')"
            >Não</b-button
          >
          <b-button colspan="6" class="ml-3" variant="primary" @click="t()"
            >Sim</b-button
          >
        </b-button-group>
      </b-modal>

      <b-modal
        ref="dialog-confirmar-a-vista"
        hide-footer
        title="Confirmação de pagamento à vista"
        size="sm"
        modal-class="small-modal"
        centered
      >
        <p>
          Não foram selecionados todos os débitos do tipo "{{
            orgaoCobranca.DESCRICAO
          }}" para esta emissão. Você deseja prosseguir com esta seleção?
        </p>

        <b-button-group class="w-100">
          <b-button
            colspan="6"
            variant="outline-secondary "
            @click="fecharModal('dialog-confirmar-a-vista')"
            >Não</b-button
          >
          <b-button
            colspan="6"
            class="ml-3"
            variant="primary"
            @click="
              abrirModalPagamentoAVistaSeNecessario('modal-pagamento-a-vista')
            "
            >Sim</b-button
          >
        </b-button-group>
      </b-modal>
      <!--  -->
    </div>
    <div id="fimPagina"></div>
  </div>
</template>


<script>
import { mask } from "vue-the-mask";
import loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import formatador from "../utils/formatarCampos";
import constantes from "../constants/index";
import { validarProcesso } from "../utils/validarNumeroProcesso";
import tabelaDebitosGrupo from "../components/tabelaDebitosGrupo.vue";
import tabelaDebitosSelecionados from "../components/tabelaDebitosSelecionados.vue";
import tabelaGuiasVista from "../components/tabelaGuiasVista.vue";
import tabelaListaParcelamento from "../components/tabelaListaParcelamento.vue";
import moment from "moment";
import tabelaAgrupamentos from "../components/tabelaAgrupamentos.vue";
import tabelaListagemCNPJ from "../components/compartilhados/tabelaListagemCNPJ.vue";
import normalizaMensagemApi from "../helpers/normalizaMensagemApi";
import { validarCPF, validarCNPJ } from '@at-siatu-tributario/tipo-identificador';
import montaCNPJSRelacionadosGovBr from '../composables/montaCNPJSRelacionadosGovBr';
import carregaTiposIdentificadores from "../composables/carregaTiposIdentificadores";

export default {
  components: {
    loading,
    tabelaDebitosGrupo,
    tabelaDebitosSelecionados,
    tabelaGuiasVista,
    tabelaListaParcelamento,
    tabelaAgrupamentos,
    tabelaListagemCNPJ,
  },
  directives: {
    mask,
  },
  data() {
    return {
      inputValue: "",
      simples: "",
      juros: "",
      multa: "",
      correcao: "",
      selic: "",
      venctoConcessaoDesconto: "",
      processoConcessaoDesconto: "",
      permiteConcederDesconto: false,
      concedeuDesconto: false,
      carregando: false,
      erroValidacaoProcesso: "",
      erroVenctoConcessaoDesconto: "",
      mensagemValidacaoProcesso: "",
      idProcessoConcessaoDesconto: "",
      processoValido: "",
      desconto: {
        numeroProcesso: "",
        descontoSimples: "",
        descontoCorrecao: "",
        descontoJuros: "",
        descontoMulta: "",
        descontoSelic: "",
        geraDescontoInscrito: "",
        dataVencimento: "",
      },
      habilitaDesabilitaCnpjCpf: false,
      cnpj: {
        valor: "",
        nome: "",
      },
      exibirEmpresaRelacionada: false,
      listaCnpjRelacionados: [],


      placeHolders_Identificador: {
        1: "Informe a Inscrição Municipal",
        3: "Informe o CPF",
        4: "Informe o CNPJ",
        5: "Informe a Perpetuidade",
        8: "Informe o Índice Cadastral",
        10: "Informe a Placa do Veículo",
        14: "Informe o Parcelamento / ano",
        15: "Informe o Processo Judicial",
        16: "Informe a Transação de ITBI / ano",
        17: "Informe o Lançamento",
      },

      config_Identificador: {
        1: {
          nome: "INSCRIÇÃO MUNICIPAL",
          placeholder: "Informe a Inscrição Municipal",
          tamanho: 15,
          mask: "#.###.###/###-J",
          validar: "validarInscricaoMunicipal"
        },
        3: {
          nome: "CPF",
          placeholder: "Informe o CPF",
          tamanho: 14,
          mask: "###.###.###-##",
          validar: "validarCPF"
        },
        4: {
          nome: "CNPJ",
          placeholder: "Informe o CNPJ",
          tamanho: 18,
          mask: "XX.XXX.XXX/XXXX-##",
          validar: "validarCNPJ"
        },
        5: {
          nome: "PERPETUIDADE",
          placeholder: "Informe a Perpetuidade",
          tamanho: 2,
          mask: "##############"
        },
        8: {
          nome: "ÍNDICE CADASTRAL",
          placeholder: "Informe o Índice Cadastral",
          tamanho: 19,
          mask: "###.###E.###E.X##.J",
          validar: "validarIPTU"
        },
        10: {
          nome: "PLACA DE VEÍCULO",
          placeholder: "Informe a Placa do Veículo",
          tamanho: 8,
          mask: "LLL-#X##"
        },
        14: {
          nome: "PARCELAMENTO",
          placeholder: "Informe o Parcelamento / ano",
          tamanho: 5,
          mask: "#######/####",
          formatar: "formataParcelamentoTransacao"
        },
        15: {
          nome: "PROCESSO JUDICIAL",
          placeholder: "Informe o Processo Judicial",
          tamanho: 20,
          mask: "####################"
        },
        16: {
          nome: "TRANSAÇÃO",
          placeholder: "Informe a Transação de ITBI / ano",
          tamanho: 5,
          mask: "#######/####",
          formatar: "formataParcelamentoTransacao"
        },
        17: {
          nome: "LANÇAMENTO",
          placeholder: "Informe o Lançamento",
          tamanho: 14,
          mask: "XXXXXXXXXXXXXX",
          validarApi: true
        }
      },

      mascaras_identificador: {
        1:  "#.###.###/###-J",          // Inscrição Municipal
        3:  "###.###.###-##",           // CPF
        4:  "XX.XXX.XXX/XXXX-##",       // CNPJ
        5:  "##############",           // Perpetuidade
        8:  "###.###E.###E.X##.J",       // Índice Cadastral
        10: "LLL-#X##",                 // Placa
        14: "#######/####",             // Parcelamento
        15: "####################",     // Processo Judicial
        16: "#######/####",             // Transação
        17: "XXXXXXXXXXXXXX",           // Lançamento
      },

      mostrarListagemCnpj: true,

      identifLancamentoPreenchido: false,
      cpfCnpjLancamento: "",

      urlGuiaDireto: "",
  
      opcaoSomenteFiltro: false, 
      pesquisandoLancamentoUrl: false,

      tooltipMaskIdentificador: "",

      identificador: "",
      tokens: {
        L: {
          pattern: /[A-Za-z ]/,
          transform: function (v) {
            return v.toLocaleUpperCase();
          },
        },
        J: {
          pattern: /[0-9xX]/,
          transform: function (v) {
            return v.toLocaleUpperCase();
          },
        },
        E: {
          pattern: /[A-Za-z0-9 ]/,
          transform: function (v) {
            if (v.match(/\d/)) return " " + v;
            else return v.toLocaleUpperCase();
          },
        },
        X: {
          pattern: /[A-Za-z0-9]/,
          transform: function (v) {
            return v.toLocaleUpperCase();
          },
        },
        "#": { pattern: /\d/ },
      },

      origemAcesso: "",
      userName: "",
      origemNome: "",
      codigoLancamentoParam: "",

      itemsGrupo: [],

      opcaoParcelaSelecionada: null,
      selected: [],
      allSelected: false,
      indeterminate: false,
      permiteParcelar: false,
      existePrescrito: false,
      exibeMensVariasOpcParc: false,
      lancamentoValido: false,

      selectAllRows: false,
      rowsPerPage: 5,
      pageSizeMenu: [5, 10, 20, 50, 100, 200],
      currentPage: 1,

      desabilitaBtnPesquisar: false,
      preencheCpfCnpjOK: false,
      preencheIdentificadorOK: false,

      cnpjsRelacionadosTabela: [],
      cnpjsRelacionadosTabelaBkp: [],

      mensagem: "",
      mensagemSucesso: [],
      mensagemErro: [],

      mensagemAlertaFormaPagto: [],

      mensagemSucessoFormaPagto: [],
      mensagemErroFormaPagto: [],
      mensagemErroConcessaoDesconto: [],

      mostrarSemEncargosMoratorios: false,
      mostrarSelecaoLancamentos: false,
      mostrarSelecaoDebitos: false,
      mostrarMensagemDebitosInexistentes: false,
      mensagemLancamentos: [],
      mensagemParcelamento: [],
      mensagemEmissaoGuia: [],
      mensagemEmissaoGuiaSucesso: [],

      mensagemValidacaoCPFCNPJ: "",
      erroValidacaoCPFCNPJ: "",

      mensagemValidacaoIdentificador: "",
      erroValidacaoIdentificador: "",

      mensagemValidacaoParcelamento: "",
      erroValidacaoParcelamento: "",

      mensagemValidacaoCodigoParcelamento: "",
      erroValidacaoCodigoParcelamento: "",

      mensagemValidacaoPlacaVeiculo: "",
      erroValidacaoPlacaVeiculo: "",

      mensagemValidacaoLancamento: "",
      erroValidacaoLancamento: "",

      desabilitacodigoNacional: true,
      desabilitaNome: false,
      desabilitaIdentificador: false,
      desabilitaParcelamento: false,
      desabilitanomeContribuinte: true,

      usuarioClicouEmPesquisar: false,

      habilitaBotaoSelecionarGuia: false,

      opcoesIdentificador: [],
      opcoesParcelar: [],

      btnSelecionados: [],
      btnSelecionadosParcelamento: [],

      parcelamentoSelecionado: [],

      dadosGuiaParcelamentoTacito: {
        pidtipoEmissao: 0,
        pidoperadorsistema: null,
        pqtdparcelas: 0,
        pvalorparcela: 0,
        pvalordeposito: 0,
        ppercdeposito: 0,
        pidregraparcelamento: 0,
        pidfaixasregras: 0,
        pListaLancamentos: [],
        pemail: "",
        ptelefone: "",
        pusuario: "",
        pListaAgrupamentos: [],
      },

      emailInformado: "",
      telefoneInformado: "",

      dadosContribuinte: {
        cadastroNacional: "",
        cpf: "",
        nomeContribuinte: "",
        cnpj: "",
        tipoIdentificador: 0,
        identificador: "",
        numeroParcelamento: "",
        placaVeiculo: "",
        codigoLancamento: "",
        processoJudicial: "",
        transacao: "",
      },
     
      // pesquisando: false,   
      permissaoAcesso: false,
      acessoMinisterioPublico: false,

      exibeAlerteIssqnEstimativa: false,
      mostrarDemaisInformacoes: false,
      mostrarErroMuitosLancamentos: false,
      informacaoContribuinte: {
        cadastroNacional: "",
        nome: "",
        idPessoa: null,
        idPessoaPapel: null,
        idParcelamento: null,
        codigoLancamento: "",
        placaVeiculo: "",
        processoJudicial: "",
        transacao: "",
        origem: "",
      },
      placeHolderIdentificador: "",
      dadosTransacao: {
        numero_transacao: "",
        ano_transacao: "",
        id_guia: "",
      },
      postagemFaixa: [],
      lancamentosSelecionados: [],
      debitosSelecionados: [],
      demaisParcelamento: [],
      parcelamentoCessao: [],
      desabilitaBtnParcelar: false,
      existeParcela: false,
      pidtipoemissao: "",
      pidoperadorsistema: "",
      mascaraIdentificador: {},
      selecLanctosParctoTacito: [],
      selecGuiasParctoTacito: [],

      forcaLimparCamposListagemCnpj: false,

      listaParcelamentosCalc: [],
      idInclusaoTributariaItbi: 0,

      listaGuias: [],
      bloquearExibirLancamentos: false,
      verLancamentos: false,
      exibirDebitos: false,
      exibirDebitosSelecionados: false,
      exibirFormaPagamento: false,
      exibirListaGuia: false,
      exibirListaGuiaParcelar: false,
      exibirParcelamento: false,
      exibeBotaoPesquisar: false,

      reinicializarSelecao: false,
      refazerAgrupamento: false,

      selecionarTodosLancamentos: false,
      cabecalhoLancamento: [
        { label: "", key: "selected" },

        {
          label: "Descrição Débito",
          key: "DESCRICAO_LANCAMENTO",
        },
        { label: "", key: "detalhar" },

        { label: "Identificador", key: "IDENTIFICADOR" },
        {
          label: "Lançamento",
          key: "CODIGO_LANCAMENTO",
        },
        { label: "", key: "detalhe" },
        {
          label: "Transação / Parcelamento",
          key: "NUMERO_PARCELAMENTO",
        },
        {
          label: "Situação",
          key: "ESTADO_LANCAMENTO",
        },
        {
          label: "Inscrito em dívida ativa",
          key: "IND_INSCRITO",
        },
        {
          label: "Valor Total",
          key: "VALOR_TOTAL", // Criado pelo template do tabela
          formatter: this.formatCurrency,
        },
        {
          label: "Valor à Vista",
          key: "VALOR_DESCONTO", // Criado pelo template do tabela
          formatter: this.formatCurrency,
        },
      ],

      cabecalhoDebitosSelecionados: [
        {
          label: "Descrição Débito",
          key: "DESCRICAO_LANCAMENTO",
        },
        { label: "", key: "detalhar" },
        { label: "Identificador", key: "IDENTIFICADOR" },
        {
          label: "Lançamento",
          key: "CODIGO_LANCAMENTO",
        },
        {
          label: "Transação / Parcelamento",
          key: "NUMERO_PARCELAMENTO",
        },
        {
          label: "Situação",
          key: "ESTADO_LANCAMENTO",
        },
        {
          label: "Inscrito em dívida ativa",
          key: "IND_INSCRITO",
        },
        {
          label: "Valor Total",
          key: "VALOR_TOTAL", // Criado pelo template do tabela
          formatter: this.formatCurrency,
        },
        {
          label: "Valor à Vista",
          key: "VALOR_DESCONTO", // Criado pelo template do tabela
          formatter: this.formatCurrency,
        },
      ],

      items: [],
      bloqueiaOpcao: false,
      fields: [],
      cabecalhoGuias: [
        {
          label: "Descrição",
          key: "DESCRICAO",
        },
        {
          label: "Numero da DRAM",
          key: "NUMEROGUIA",
          formatter: this.formatGuia,
        },
        {
          label: "Vencimento",
          key: "DATAVENCIMENTO",
          formatter: this.formatDateTime,
        },
        {
          label: "Valor total",
          key: "VALORTOTAL",
          formatter: this.formatCurrency,
        },
        {
          label: "Valor com desconto",
          key: "VALORDESCONTO",
          formatter: this.formatCurrency,
        },
        {
          label: "",
          key: "URLEMISSAO",
        },
        {
          label: "",
          key: "URLRELACAO",
        },
      ],

      cabecalhosubitem: [
        { label: "", key: "lista_opcao_parcto" },

        {
          label: "Parcela",
          key: "AQtdParcela",
        },

        {
          label: "Valor parcela",
          key: "AVlrParcela",
          formatter: this.formatCurrency,
        },

        {
          label: "Valor desconto",
          key: "AVlrdesconto",
          formatter: this.formatCurrency,
        },
      ],

      cabecalhoGuiasParcelado: [
        { label: "", key: "selected" },
        {
          key: "lista_opcao_parcto",
        },
        {
          label: "Descrição",
          key: "descricao_grupo",
        },
        {
          label: "lista_lancamento",
          key: "lista_lancamento",
        },
      ],

      listaDemaisParcelamentos: [],
      escolhaDemaisParcelamentos: "",

      listaCessao: [],
      escolhaCessao: "",

      cabecalhoEmissaoGuia: [
        {
          label: "Número do Parcelamento",
          key: "NROPARCELAMENTO",
        },
        {
          label: "Quantidade de Parcelas",
          key: "QTDPARCELAS",
        },
        {
          label: "Quantidade de Parcelas em Aberto",
          key: "QTDPARCELASABERTAS",
        },
        {
          label: "Saldo Atualizado",
          key: "VALORATUALIZADO",
          formatter: this.formatCurrency,
        },
        {
          label: "Valor à vista com desconto",
          key: "VALORDESCONTO",
          formatter: this.formatCurrency,
        },
      ],

      opcoesOrgaosCobranca: [],
      orgaoCobranca: [],
      orgao: [],
      listaAgrupamentos: [],
      listaNiveis: [],

      lancamentos: [],
      carregandoTabelaLancamentos: false,

      calculos: {
        OPCOES_PARCTO_CESSAO: [],
        OPCOES_PARCTO_DEMAIS: [],
        LANCAMENTO_CESSAO: [],
        LANCAMENTO_DEMAIS: [],
      },

      cnpjsSelecionado: "",
      cnpjRelacionadoFoiSelecionado: false,

      calculosNovo: [],
      opcoesParcelamento: [],

      somenteParcelado: false,
      mostrarCessao: false,
      mostrarDemais: false,

      permitirCancelar: false,
      bloqueioEmissaoGuia: false,
      lancamentosEmissaoGuia: [],

      popoverShow: false,

      proibidos: [],

      informacoesEmissaoGuia: {
        cpfCnpj: "",
        razaoSocial: "",
        telefoneCelular: "",
        email: "",
        codigoEmissaoGuia: "",
        confirmacao: "",
        emailEnviado: false,
        telefoneEnviado: false,
        listaParcelamento: [],
        dadosExibicao: [],
      },

      tokenEmissaoGuia: "",
      mostrarConfirmacaoEmissaoGuia: false,

      informacaoParcelamento: {
        telefone: "",
        email: "",
      },

      listaGuiasParcelamento: [],
      listaDramParcelamento: [],
      listaOpcoesParcelamentoInternas: [],
      opcoesParcto: [],
      opcaoParctoSelecionada: "",
      escolhaOpcaoParcelamentoInterna: "",
      listaUrlsGuias: [],
    };
  },
  methods: {
    validacaoCPFCNPJ: function () {
      let tamCampo = 0;
      let txt = "";
      let formato = "";
      let tipo = this.dadosContribuinte.cadastroNacional.length;

      this.preencheCpfCnpjOK = false;

      //CPF
      if (tipo <= 14) {
        tamCampo = 14;
        txt = "CPF";
      } else {
        //CNPJ
        tamCampo = 18;
        txt = "CNPJ";
      }

      if (this.dadosContribuinte.cadastroNacional.length <= tamCampo) {
        this.mensagemValidacaoCPFCNPJ = txt + " digitado está incompleto";
        formato = "text-danger";
        this.preencheCpfCnpjOK = false;
      }
      if (tipo == 14) {
        if (validarCPF(this.dadosContribuinte.cadastroNacional)) {
          this.mensagemValidacaoCPFCNPJ = txt + " digitado é válido";
          formato = "text-success";
          this.preencheCpfCnpjOK = true;
        } else {
          this.mensagemValidacaoCPFCNPJ =
            txt + " - dígito verificador inválido";
          formato = "text-danger";
          this.preencheCpfCnpjOK = false;
        }
      }
      // cnpj
      else if (tipo == 18) {
        if (validarCNPJ(this.dadosContribuinte.cadastroNacional)) {
          this.mensagemValidacaoCPFCNPJ = txt + " digitado é válido";
          formato = "text-success";
          this.preencheCpfCnpjOK = true;
        } else {
          this.mensagemValidacaoCPFCNPJ =
            txt + " - dígito verificador inválido";
          formato = "text-danger";
          this.preencheCpfCnpjOK = false;
        }
      }
      this.habilitaDesabilitaCnpjCpf = this.preencheCpfCnpjOK;
      this.erroValidacaoCPFCNPJ = formato;

      if (this.dadosContribuinte.identificador === "") {
        this.mensagemValidacaoIdentificador = "";
      }
      if (this.dadosContribuinte.cadastroNacional === "") {
        this.mensagemValidacaoCPFCNPJ = "";
      }
    },

    validarCNPJ(valor) {
      return validarCNPJ(valor);
    },

    validarCPF(valor) {
      return validarCPF(valor);
    },

    async verificaSeCnpjRelacionadoExiste(cnpjParaVerificar = null) {
      if (!cnpjParaVerificar) {
        console.warn('Nenhum CNPJ fornecido para verificação. Verificando todos os CNPJs relacionados.');
        return false;
      }
      cnpjParaVerificar = cnpjParaVerificar.replace(/\D/g, '');
      let cnpjs = [];
      // pega CNPJS relacionados do Gov
      if (this.$store.getters.userInfo && this.$store.getters.userInfo.attributes) {
        const cnpjsGov = montaCNPJSRelacionadosGovBr(this.$store.getters.userInfo.attributes);
        // adiciona os cnpjs relacionados da tabela, caso existam e não estejam na lista
        cnpjs = [
          ...cnpjsGov,
          ...this.cnpjsRelacionados.filter((cnpj) => !cnpjsGov.some((c) => c.cnpj === cnpj.cnpj))
        ];
      }
      // pega CNPJs relacionados da tabela, caso existam
      if (this.cnpjsRelacionadosTabela && this.cnpjsRelacionadosTabela.length > 0) {
        cnpjs = [
          ...cnpjs,
          ...this.cnpjsRelacionadosTabela.filter((cnpj) => !cnpjs.some((c) => c.cnpj === cnpj.cnpj))
        ];
      }
      return cnpjs.some((c) => c.cnpj.replace(/\D/g, '') === cnpjParaVerificar);
    },

    async validarIdentificador(valor) {
        if (!valor || !this.identificadorConfig) {
          this.mensagemValidacaoIdentificador = "";
          return;
        }

        const {
          nome,
          tamanho,
          validar,
          validarApi,
          formatar
        } = this.identificadorConfig;

        let identificador = valor;

        if (formatar) {
          identificador = this[formatar](identificador);
          this.dadosContribuinte.identificador = identificador;
        }

        const completo = identificador.length >= tamanho;
        let valido = completo;
        let mensagem = completo
          ? `${nome} digitado(a) é válido(a)`
          : `${nome} digitado(a) está incompleto(a)`;
        let classe = completo ? "text-success" : "text-danger";
        if (completo && validar) {
          valido = this[validar](identificador);
          mensagem = valido
            ? `${nome} digitado(a) é válido(a)`
            : `${nome} - dígito verificador inválido`;
          classe = valido ? "text-success" : "text-danger";
        }

        if (completo && validarApi) {
          this.cpfCnpjLancamento = await this.validarLancamento(identificador);
          mensagem = this.cpfCnpjLancamento != null 
            ? `${nome} digitado é válido`
            : `${nome} digitado não existe na base de dados`;
          classe = valido ? "text-success" : "text-danger";
        }

        this.preencheIdentificadorOK = valido;
        this.mensagemValidacaoIdentificador = mensagem;
        this.erroValidacaoIdentificador = classe;

        this.desabilitarCampos();
    },

    async validarLancamento(valor) {
      try {
        const { data } = await this.$axios.post(
          this.$env.url_backend + constantes.verificaLancamento,
          { lancamento: valor }
        );
        return data.length > 0 ? data[0].CODIGO_NACIONAL : null;

      } catch (err) {
        this.limparCampos();
        return false;
      }
    },

    focusInput(id) {
      this.$nextTick(() => document.getElementById(id)?.focus());
    },    

    consisteCamposConcessao() {
      let dtSys = new Date();
      const vencimento = this.venctoConcessaoDesconto
        ? new Date(
            moment(this.venctoConcessaoDesconto)
              .add(23, "hours")
              .add(59, "minutes")
              .add(59, "seconds")
              .format("YYYY-MM-DD HH:mm:ss")
          )
        : null;
      this.mensagemErroConcessaoDesconto = [];
      if (
        // Checa se pelo menos um dos valores no array não é null e não é uma string vazia. //
        [this.juros, this.multa, this.correcao, this.selic].some(
          (value) => value !== null && value !== ""
        )
      ) {
        if (!this.venctoConcessaoDesconto)
          this.mensagemErroConcessaoDesconto.push(
            "Data de vencimento deverá ser preenchida."
          );
        if (!this.processoConcessaoDesconto)
          this.mensagemErroConcessaoDesconto.push(
            "O processo deverá ser preenchido."
          );
      }
      if (vencimento < dtSys && this.venctoConcessaoDesconto !== "")
        this.mensagemErroConcessaoDesconto.push(
          "Data de vencimento não pode ser menor que data do sistema."
        );
    },

    dentroIntervalo(value) {
      const percent = value.replace(",", ".");
      const parsedValue = parseFloat(percent);
      const apenasNumerosEVirgula = /^[0-9,]*$/;
      const result =
        !isNaN(parsedValue) &&
        parsedValue <= 100 &&
        parsedValue >= 1 &&
        apenasNumerosEVirgula.test(value);
      return result;
    },

    liberaBtnSemDesconto() {
      let result =
        this.juros == "" &&
        this.multa == "" &&
        this.correcao == "" &&
        this.selic == "" &&
        this.processoConcessaoDesconto == "";
      return !result;
    },

    liberaBtnConcessaoDesconto() {
      let result = true;
      if (this.juros !== "" && this.juros !== null)
        result = this.dentroIntervalo(this.juros);
      if (result && this.multa !== "" && this.multa !== null)
        result = this.dentroIntervalo(this.multa);
      if (result && this.correcao !== "" && this.correcao !== null)
        result = this.dentroIntervalo(this.correcao);
      if (result && this.selic !== "" && this.selic !== null)
        result = this.dentroIntervalo(this.selic);
      if (result) result = this.processoValido;
      return !result;
    },

    verificaPercentual(value, nomePercentual) {
      this.onInputExit(value, nomePercentual);
    },

    onInputExit(value, nomePercentual) {
      const apenasNumerosEVirgula = /^[0-9,]*$/;
      if (value && apenasNumerosEVirgula.test(value)) {
        let valor = parseFloat(value.replace(",", "."));
        if (valor > 100) {
          this.mensagemErroConcessaoDesconto.push(
            "Valor do percentual de " +
              nomePercentual +
              " não pode ser maior que 100."
          );
        }
        if (valor < parseFloat(1.0)) {
          this.mensagemErroConcessaoDesconto.push(
            "Valor do percentual de " +
              nomePercentual +
              " não pode ser menor que 1."
          );
        }
      } else if (value) {
        this.mensagemErroConcessaoDesconto.push(
          "Valor do percentual de " + nomePercentual + " está inválido."
        );
      }
    },

    validaPercentualDigitado(value, opc) {
      const apenasNumerosEVirgula = /^[0-9,]*$/;

      if (!apenasNumerosEVirgula.test(value)) return "";

      // Mapeamento de opções para propriedades
      const campos = {
        1: "juros",
        2: "multa",
        3: "correcao",
        4: "selic",
      };

      const campo = campos[opc];
      if (!campo) return ""; // caso opc inválido

      this[campo] = this[campo] ? this.validaValorPercentual(value) : "";
    },

    validaValorPercentual(value) {
      let result = "";
      let atingiuTamanhoMax = "";
      //   Remover caracteres inválidos, exceto números e vírgula
      value = value.replace(/[^0-9,]/g, "");
      // Dividir o valor em antes e depois da vírgula
      let [antesVirgula, depoisVirgula] = value.split(",");
      // Limitar a 3 números antes da vírgula
      antesVirgula = antesVirgula.slice(0, 3);
      // Truncar para 3 números após a vírgula, se existir
      if (depoisVirgula !== undefined) {
        depoisVirgula = depoisVirgula.slice(0, 3);
      }
      // Adicionar automaticamente a vírgula se mais de 3 números forem digitados sem ela
      if (value.length > 3 && !value.includes(",")) {
        depoisVirgula = value.slice(3).replace(/\D/g, "").slice(0, 3);
      }
      // Limitar a 3 números depois da vírgula, se existir
      depoisVirgula = depoisVirgula ? depoisVirgula.slice(0, 3) : "";
      const partes = value.split(",");
      // Retornar o tamanho da parte decimal
      if (partes[1] && partes[1].length > 3) atingiuTamanhoMax = "S";
      // tamanho total do valor digital
      else if (value.length > 7) atingiuTamanhoMax = "S";
      else atingiuTamanhoMax = "N";
      // Atualizar o valor final
      // if (value.length < 8 || partes[1].length < 4){
      if (atingiuTamanhoMax == "N") {
        result = depoisVirgula
          ? `${antesVirgula},${depoisVirgula}`
          : antesVirgula;
      }
      return result;
    },

    async consistenumeroProcesso(processo) {
      let tamCampo = 0;
      let txt = "";
      let formato = "";
      let len = processo.length;
      let processoOK = false;
      //Processo
      txt = "Processo";
      if (len <= 14) tamCampo = 14;
      else tamCampo = 19;
      if (processo.length <= tamCampo) {
        this.mensagemValidacaoProcesso = txt + " digitado está incompleto";
        formato = "text-danger";
        processoOK = false;
      }
      let numProcesso = processo.replace(/[^\w\s]/g, "");
      if (len == 14) {
        let DVconfereOK = validarProcesso(numProcesso);
        if (DVconfereOK) {
          processoOK = true;
        } else {
          this.mensagemValidacaoProcesso =
            txt + " - dígito verificador inválido";
          formato = "text-danger";
          processoOK = false;
        }
      } else if (len == 19) {
        processoOK = true;
      } else {
        this.mensagemValidacaoProcesso = txt + " digitado está incompleto";
        formato = "text-danger";
        processoOK = false;
      }
      if (processoOK) {
        let idProcesso = "";
        await this.$axios
          .post(this.$env.url_backend + constantes.buscarIdProcesso, {
            processoInclusao: numProcesso,
          })
          .then((response) => {
            const retorno = response.data;
            idProcesso = retorno[0];
            if (idProcesso == null) {
              this.mensagemValidacaoProcesso = "PROCESSO não cadastrado";
              this.erroValidacaoProcesso = "text-danger";
            } else {
              this.mensagemValidacaoProcesso = txt + " digitado é válido";
              formato = "text-success";
              this.idProcessoConcessaoDesconto = idProcesso;
            }
            processoOK = idProcesso !== null;
          })
          .catch((err) => {
            this.mensagemValidacaoProcessoNovo = normalizaMensagemApi(err);
            this.erroValidacaoProcessoNovo = "text-danger";
            this.carregando = false;
          });
      }
      this.erroValidacaoProcesso = formato;

      if (processo == "") {
        this.mensagemValidacaoProcesso = "";
      }
      this.processoValido = processoOK;
    },

    preventPaste(event) {
      // Previne a ação de colar no campo
      event.preventDefault();
      this.mensagemErroConcessaoDesconto = [];
      this.mensagemErroConcessaoDesconto.push("Digite o valor manualmente.");
    },

    formatarValorComData: function () {
      var elemento = document.getElementById("valor");
      var valor = elemento.value;

      valor = valor + "";
      valor = parseInt(valor.replace(/[\D]+/g, ""));
      valor = valor + "";
      valor = valor.replace(/([0-9]{4})$/g, "/$1");
      elemento.value = valor;
      if (valor == "NaN") elemento.value = "";
    },

    verificaPreenchimento() {
      if (this.dadosContribuinte.identificador === "") {
        this.mensagemValidacaoIdentificador = "";
      }
      if (this.dadosContribuinte.cadastroNacional === "") {
        this.mensagemValidacaoCPFCNPJ = "";
      }
      let opc = false;
      if (
        this.dadosContribuinte.cadastroNacional === "" &&
        this.dadosContribuinte.identificador === ""
      ) {
        opc = false;
      } else if (
        this.dadosContribuinte.cadastroNacional === "" &&
        this.dadosContribuinte.identificador != ""
      ) {
        opc = this.preencheIdentificadorOK;
      } else if (
        this.dadosContribuinte.cadastroNacional != "" &&
        this.dadosContribuinte.identificador === ""
      ) {
        opc = this.preencheCpfCnpjOK;
      } else {
        opc = this.preencheIdentificadorOK && this.preencheCpfCnpjOK;
      }

      return !opc;
    },

    existeLancamento: async function (lancamento) {
      await this.$axios
        .post(this.$env.url_backend + constantes.verificaLancamento, {
          lancamento: lancamento,
        })
        .then((response) => {
          const retorno = response.data;
          this.lancamentoValido = retorno[0].QTE > 0 ? true : false;
        })
        .catch((err) => {
          this.carregando = false;
          this.limparCampos();
          const mensagem = normalizaMensagemApi(err);
          this.mensagemErro.push({
            mensInicio: mensagem,
            mensLink: "",
            mensFim: "",
          });
          window.scrollTo(0, 0);
        });
    },

    _pesquisarValidarObrigatorios() {
      if (this.dadosContribuinte.tipoIdentificador === 16 && this.dadosContribuinte.cadastroNacional == "") {
        this.mensagemErro.push({ mensInicio: "É obrigatório o preenchimento do CPF/CNPJ.", mensLink: "", mensFim: "" });
        window.scrollTo(0, 0);
        this.carregando = false;
        return false;
      }
      return true;
    },

    _pesquisarResetarEstado() {
      this.mensagemErro = [];
      this.mensagemSucesso = [];
      this.desabilitarAba("all");
      this.calculos = { OPCOES_PARCTO_CESSAO: [], OPCOES_PARCTO_DEMAIS: [], LANCAMENTO_CESSAO: [], LANCAMENTO_DEMAIS: [] };
      this.reinicializarSelecao = true;
      this.orgaoCobranca = [];
      this.novaPesquisa = "S";
      this.mostrarErroMuitosLancamentos = false;
      this.bloquearExibirLancamentos = false;
      this.mostrarSemEncargosMoratorios = false;
      this.limparMensagensDeErro();
    },

    _pesquisarPrepararIdentificador() {
      const tipo = this.dadosContribuinte.tipoIdentificador;
      const id = this.dadosContribuinte.identificador;
      if (tipo === 10) this.dadosContribuinte.placaVeiculo = id;
      if (tipo === 14) this.dadosContribuinte.numeroParcelamento = id;
      if (tipo === 17) this.dadosContribuinte.codigoLancamento = id;
      if (tipo === 15) this.dadosContribuinte.processoJudicial = id;
      if (tipo === 16) {
        this.dadosContribuinte.identificador = id.slice(0, 12);
        this.dadosContribuinte.transacao = this.dadosContribuinte.identificador;
      }
    },

    _pesquisarMontarParametros() {
      const pContribuinte = { ...this.dadosContribuinte };
      pContribuinte.cadastroNacional = this.dadosContribuinte.cadastroNacional;
      pContribuinte.nomeContribuinte = this.dadosContribuinte.nomeContribuinte;
      if (this.dadosContribuinte.tipoIdentificador === 17) pContribuinte.identificador = "";
      if (this.origemAcesso !== "GovBr") return pContribuinte;

      if (this.cnpj.valor?.length > 0) {
        pContribuinte.cadastroNacional = this.cnpj.valor || this.dadosContribuinte.cadastroNacional;
        pContribuinte.nomeContribuinte = this.cnpj.nome || this.dadosContribuinte.nomeContribuinte;
      } else if (this.dadosContribuinte.identificador.length > 0) {
        pContribuinte.cadastroNacional = "";
        pContribuinte.nomeContribuinte = "";
      }
      return pContribuinte;
    },

    _pesquisarValidarAcessoAD() {
      if (this.origemAcesso !== "AD") return true;
      if (this.dadosContribuinte.cadastroNacional.length === 0) return true;
      if (this.cpfCnpjAcessado === this.dadosContribuinte.cadastroNacional.replace(/[^a-zA-Z0-9]+/g, "")) return true;

      this.carregando = false;
      this.carregandoTabelaLancamentos = false;
      this.codigoLancamentoParam = "";
      this.mensagemErro.push({ mensInicio: "Opção de Debito Específico não pertence ao CPF/CNPJ informado", mensLink: "", mensFim: "" });
      window.scrollTo(0, 0);
      return false;
    },

    async _pesquisarValidarAcessoGovBr(infoContribuinteRetorno) {
      if (this.origemAcesso !== "GovBr") return true;
      const identificador = this.dadosContribuinte?.identificador;
      if (!identificador?.length) return true;

      this.cpfCnpjLancamento = infoContribuinteRetorno.CODIGO_NACIONAL;
      const cadastroNacional = this.dadosContribuinte?.cadastroNacional;
      const cpfCnpjCadastro = this.cnpj.valor.length > 0
        ? this.cnpj.valor.replace(/[^a-zA-Z0-9]+/g, "")
        : cadastroNacional?.replace(/[^a-zA-Z0-9]+/g, "");
      const ehMesmoCpfCnpj = this.cpfCnpjAcessado === cpfCnpjCadastro;
      // verifica se o cnpj do lançamento está entre os cnpjs relacionados do usuário
      const ehCnpjRelacionado = await this.verificaSeCnpjRelacionadoExiste(this.cpfCnpjAcessado);
      const naoPossuiPermissao = !ehMesmoCpfCnpj && !ehCnpjRelacionado;

      if (naoPossuiPermissao) {
        this.carregando = false;
        this.carregandoTabelaLancamentos = false;
        this.codigoLancamentoParam = "";
        this.mensagemErro.push({ mensInicio: "Opção de Debito Específico não pertence ao CPF/CNPJ informado", mensLink: "", mensFim: "" });
        window.scrollTo(0, 0);
        return false;
      }
      this.cnpj.valor = infoContribuinteRetorno.CODIGO_NACIONAL;
      this.cnpj.nome = infoContribuinteRetorno.NOME;
      return true;
    },

    _pesquisarPreencherInformacaoContribuinte(infoContribuinteRetorno) {
      if (this.origemAcesso !== "GovBr") {
        this.dadosContribuinte.cadastroNacional = infoContribuinteRetorno.CODIGO_NACIONAL;
        this.dadosContribuinte.nomeContribuinte = infoContribuinteRetorno.NOME;
      }
      this.informacaoContribuinte.cadastroNacional = infoContribuinteRetorno.CODIGO_NACIONAL;
      this.informacaoContribuinte.idPessoa = infoContribuinteRetorno.ID_PESSOA;
      this.informacaoContribuinte.idPessoaPapel = infoContribuinteRetorno.ID_PESSOA_PAPEL;
      this.informacaoContribuinte.idParcelamento = infoContribuinteRetorno.ID_PARCELAMENTO;
      this.informacaoContribuinte.codigoLancamento = this.dadosContribuinte.codigoLancamento;
      //SDM 4187953
      this.informacaoContribuinte.origem = this.origemAcesso;
      this.informacaoContribuinte.placaVeiculo = this.dadosContribuinte.placaVeiculo === ""
        ? null
        : this.dadosContribuinte.placaVeiculo.replace(/[^\w\s]/g, "");
      this.informacaoContribuinte.processoJudicial = this.dadosContribuinte.processoJudicial === ""
        ? null
        : this.dadosContribuinte.processoJudicial.replace(/[^\d| |\w]+/g, "");
      this.informacaoContribuinte.transacao = this.dadosContribuinte.transacao === ""
        ? null
        : this.dadosContribuinte.transacao;
    },

    async _pesquisarTratarRetornoOk(infoContribuinteRetorno) {
      this.mensagemErro = [];
      this.mostrarDemaisInformacoes = true;
      this.informacaoContribuinte.nome = infoContribuinteRetorno.NOME;
      this.habilitaDesabilitaCnpjCpf = true;
      this.cpfCnpjAcessado = infoContribuinteRetorno.CODIGO_NACIONAL;

      if (!this._pesquisarValidarAcessoAD()) return;
      if (!(await this._pesquisarValidarAcessoGovBr(infoContribuinteRetorno))) return;

      this._pesquisarPreencherInformacaoContribuinte(infoContribuinteRetorno);

      const cadastro = this.dadosContribuinte?.cadastroNacional;
      const cpfCnpj = cadastro ? cadastro.replace(/[^a-zA-Z0-9]+/g, "") : "";

      if (this.informacaoContribuinte.idParcelamento) {
        this.btnSelecionadosParcelamento = [];
        await this.abreGuiaParcelamento();
        if (this.listaDramParcelamento.length > 0) {
          this.downloadArquivo(this.listaDramParcelamento[0].URLEMISSAO, "emissaoDRAM");
          this.exibirParcelamento = true;
        }
      } else if (!this.proibidos.includes(cpfCnpj)) {
        await this.lancamentosAgrupados();
      } else {
        this.carregando = false;
        this.mostrarErroMuitosLancamentos = true;
      }
      this.posicionaPagina();
    },

    async _pesquisarTratarRetornoErro(infoContribuinteRetorno) {
      this.dadosContribuinte.identificador = this.dadosContribuinte.identificador.replace(/[^a-zA-Z0-9]+/g, "");
      this.dadosContribuinte.identificador = "";
      this.calculos = { OPCOES_PARCTO_CESSAO: [], OPCOES_PARCTO_DEMAIS: [], LANCAMENTO_CESSAO: [], LANCAMENTO_DEMAIS: [] };
      this.informacaoContribuinte = {};
      this.mostrarDemaisInformacoes = false;
      this.mostrarSelecaoLancamentos = false;
      this.mostrarSelecaoDebitos = false;
      this.mostrarErroMuitosLancamentos = false;
      this.orgaoCobranca = [];
      this.carregando = false;

      const limparEMostrarMensagem = () => {
        this.dadosContribuinte.tipoIdentificador = 0;
        this.dadosContribuinte.identificador = "";
        const mensagem = this.verificaLinkMens(infoContribuinteRetorno.MENSAGEM_RETORNO);

        this.mensagemErro.push(mensagem);
        window.scrollTo(0, 0);
      };

      const deveExibirMensagemDireta =
        (this.origemAcesso === "GovBr" && this.cnpj.valor.length > 0) || this.origemAcesso === "AD";
      if (deveExibirMensagemDireta) {
        limparEMostrarMensagem();
        return;
      }

      const cnpjRelacionado = this.cnpj.valor.replace(/[^a-zA-Z0-9]+/g, "");
      const localizado = await this.verificaSeCnpjRelacionadoExiste(cnpjRelacionado);
      this.limparCampos();
      if (!localizado) {
        limparEMostrarMensagem();
        return;
      }
      this.mensagemErro.push({
        mensInicio: "Não foram encontrados débitos para esta consulta. Para emissão de CND",
        mensLink: "https://cnd.pbh.gov.br/CNDOnline/",
        mensFim: ""
      });
      this.carregando = false;
      window.scrollTo(0, 0);
    },

    _pesquisarTratarErroAxios(err, funcaoCallback) {
      this.carregando = false;
      this.limparCampos();
      const mensagem = normalizaMensagemApi(err);
      this.mensagemErro.push({ mensInicio: mensagem, mensLink: "", mensFim: "" });
      window.scrollTo(0, 0);
      if (funcaoCallback) funcaoCallback(null);
    },

    formatarNumeroAno(valor) {
      const partes = valor.split('/');

      if (partes.length !== 2) {
          throw new Error('Formato inválido. Use numero/ano.');
      }

      const [numero, ano] = partes;

      if (!/^\d+$/.test(numero) || !/^\d+$/.test(ano)) {
          throw new Error('Número e ano devem conter apenas dígitos.');
      }

      return `${numero.padStart(7, '0')}/${ano.padStart(4, '0')}`;
    },

    pesquisar: async function (funcaoCallback = null) {
      this.opcaoSomenteFiltro = this.dadosContribuinte.cadastroNacional == "";
      this.carregando = true;
      this.desabilitaBtnParcelar = false;
      this.mostrarListagemCnpj = false;
      this.cnpjRelacionadoFoiSelecionado = true;

      // if (!this._pesquisarValidarObrigatorios()) return;
      
      this.inicializarCampos();
      let auxIdentificador = this.dadosContribuinte.identificador;

      if (this.dadosContribuinte.tipoIdentificador == 16) 
           auxIdentificador = this.formatarNumeroAno(this.dadosContribuinte.identificador);
          
      const auxTipoIdentificador = this.dadosContribuinte.tipoIdentificador;
  
      this._pesquisarResetarEstado();
      this._pesquisarPrepararIdentificador();

      this.usuarioClicouEmPesquisar = true;
      this.dadosContribuinte.tipoIdentificador = this.dadosContribuinte.tipoIdentificador || null;

      const pContribuinte = this._pesquisarMontarParametros();

      await this.$axios
        .post(this.$env.url_backend + constantes.buscarContribuinte, { dadosContribuinte: pContribuinte })
        .then(async (response) => {
          const retorno = response.data;
          this.dadosContribuinte.identificador = auxIdentificador;
          this.dadosContribuinte.tipoIdentificador = auxTipoIdentificador;

          const infoContribuinteRetorno = retorno[0];

          if (infoContribuinteRetorno.MENSAGEM_RETORNO === "OK") {
            await this._pesquisarTratarRetornoOk(infoContribuinteRetorno);
          } else {
            await this._pesquisarTratarRetornoErro(infoContribuinteRetorno);
          }

          this.desabilitaNome = true;
          this.desabilitaIdentificador = true;

          if (funcaoCallback) funcaoCallback(infoContribuinteRetorno);
        })
        .catch((err) => {
          this._pesquisarTratarErroAxios(err, funcaoCallback);
        });

      if (this.dadosContribuinte.identificador != "") {
        this.dadosContribuinte.identificador = this.dadosContribuinte.identificador.replace(/[^a-zA-Z0-9]+/g, "");
        this.dadosContribuinte.identificador = auxIdentificador;
      }
    },

    itbiPorTransacao: async function (transacao) {
      this.dadosTransacao.numero_transacao = transacao.substring(
        0,
        this.dadosContribuinte.transacao.length - 4
      );
      this.dadosTransacao.numero_transacao =
        this.dadosTransacao.numero_transacao.replace(/[^\d]+/g, "");
      let length =
        7 - this.dadosTransacao.numero_transacao.toString().length + 1;
      this.dadosTransacao.numero_transacao =
        Array(length).join("0") + this.dadosTransacao.numero_transacao;
      this.dadosTransacao.ano_transacao = transacao.substring(
        this.dadosContribuinte.transacao.length - 4
      );
      this.id_guia = "";

      await this.$axios
        .post(this.$env.url_backend + constantes.buscarIDtransacaoITBI, {
          dadosTransacao: this.dadosTransacao,
        })
        .then((response) => {
          const retorno = response.data;
          let idTransacao = retorno[0].ID_INCLUSAO_TRIBUTARIA_ITBI;

          //  monta dados para parcelamento da transacao  //
          let lista = {};
          lista.ID_LANCAMENTO = idTransacao;
          lista.AGRUPAMENTO = 5;
          this.lancamentosSelecionados.push(lista);

          this.exibirListaGuiaParcelar = false;
          this.exibirListaGuia = false;
          this.exibirFormaPagamento = false;
          this.retornaCalculosParcelar();
        })
        .catch((err) => {
          this.carregando = false;
          const mensagem = normalizaMensagemApi(err);
          this.mensagemErro.push({
            mensInicio: mensagem,
            mensLink: "",
            mensFim: "",
          });
          window.scrollTo(0, 0);
        });
    },

    montaSelecionado(codigoNacional, razaoSocial) {
      this.cnpj.valor = codigoNacional;
      if (this.cnpj.valor.length === 11) {
          this.cnpj.valor = formatador.formataCPF(
              this.cnpj.valor
        );
      } else {
         this.cnpj.valor = formatador.formataCNPJ(
           this.cnpj.valor
        );
      }
      this.cnpj.nome = razaoSocial;
    },

    guiaPagamentoAVista(url, ind1) {
      const str1 = ind1;
      this.chaveID = `${str1}`;
      const ind = this.btnSelecionadosParcelamento.findIndex(
        (e) => e.id === this.chaveID
      );

      // se já foi clicado ( existe na lista), remove
      if (ind !== -1) {
        this.btnSelecionadosParcelamento =
          this.btnSelecionadosParcelamento.filter(
            (item) => item.id != this.chaveID
          );
      } // inclui ( clicado )
      else {
        this.btnSelecionadosParcelamento.push({ id: this.chaveID });
        const link = url;
        this.downloadArquivo(link, "emissaoDRAM");
      }
    },

    downloadArquivo: async function (pathurl) {
      window.open(pathurl);
    },

    abreGuiaParcelamento: async function () {
        ////  verificando se tem algum lancamento inscrito em divida ativa - sdm 4909857  /// 
        let temSomenteLancamentoInscritoDividaAtiva = false;
        if (this.acessoMinisterioPublico) {
            await this.$axios
              .post(this.$env.url_backend + constantes.verficaParcelamentoInscritoDA, {
                idParcelamento: this.informacaoContribuinte.idParcelamento,
              })
              .then((response) => {
                const retorno = response.data;            
                temSomenteLancamentoInscritoDividaAtiva = retorno;
              })
              .catch((err) => {
                window.scrollTo(0, 0);
                const mensagem = normalizaMensagemApi(err);
                this.mensagemErroFormaPagto.push(mensagem);
              })
              .finally(() => {
                this.carregando = false;
              });
        }    
      ///  sdm 4909857 ///
      if ((!this.acessoMinisterioPublico) ||
          (this.acessoMinisterioPublico && temSomenteLancamentoInscritoDividaAtiva && this.informacaoContribuinte.cadastroNacional.length == 11) || 
          (this.acessoMinisterioPublico && this.informacaoContribuinte.cadastroNacional.length > 11)) {
            await this.$axios
              .post(this.$env.url_backend + constantes.retornaGuiaParcelamento, {
                idParcelamento: this.informacaoContribuinte.idParcelamento,
                usuario: this.userName,
              })
              .then((response) => {
                this.listaGuiasParcelamento = [];
                const retorno = response.data;
                const objetoGuiasParcelamento = retorno[0];
                if (objetoGuiasParcelamento.AMENSAGEM_RETORNO === "OK") {
                  this.listaGuiasParcelamento = objetoGuiasParcelamento.ALISTA;
                  this.listaDramParcelamento = this.montalistaDramParcelamento(
                    this.listaGuiasParcelamento
                  );
                  this.carregando = false;
                } else {
                  this.carregando = false;
                  this.exibirParcelamento = false;
                  // this.limparCampos();
                  let msg = "";
                  if (objetoGuiasParcelamento.AMENSAGEM_RETORNO.includes("Programa Esporte para Todos"))
                      msg = "Para parcelamentos do Programa Esporte para Todos deverá ser solicitado o DRAM clique https://sigesp.pbh.gov.br";
                  else 
                      msg = objetoGuiasParcelamento.AMENSAGEM_RETORNO;            
                  this.mensagem = this.verificaLinkMens(
                    msg
                  );
                  this.mensagemErro.push(this.mensagem);
                  window.scrollTo(0, 0);
                }
              })
              .catch((err) => {
                this.carregando = false;
                this.limparCampos();
                const mensagem = normalizaMensagemApi(err);
                this.mensagemErro.push({
                  mensInicio: mensagem,
                  mensLink: "",
                  mensFim: "",
                });
                window.scrollTo(0, 0);
              });
        } else {
                  this.mensagem = "Não foram encontrados débitos em Dívida Ativa para esta consulta.";
                  this.mensagemErro.push(this.mensagem);
                  window.scrollTo(0, 0);             
              }  
        ///      
    },

    lancamentosAgrupados: async function () {    
      this.carregandoTabelaLancamentos = true;
      this.listaDemaisParcelamentos = [];
      this.listaCessao = [];
      this.mensagemErro = [];
      this.mostrarMensagemDebitosInexistentes = false;

      if (this.informacaoContribuinte.transacao != null) {
        this.informacaoContribuinte.idPessoa = null;
        this.informacaoContribuinte.idPessoaPapel = null;
      }
      // sdm 4289130 - Wagner - verifica se usuario comum tem ISSQN estimativa //
      if (this.origemAcesso != "AD" && this.origemAcesso != "GovBr") {
        this.informacaoContribuinte.cadastroNacional = "";
        await this.$axios
          .post(
            this.$env.url_backend + constantes.verificaIRestricaoTributoUsuarioNaoLogado,
            {
              idPessoa: this.informacaoContribuinte.idPessoa,
            }
          )
          .then((response) => {
            const retorno = response.data;
            this.exibeAlerteIssqnEstimativa = !!retorno[0].COUNT;
          })
          .catch(() => {
            this.exibeAlerteIssqnEstimativa = false;
          });
      }
      this.informacaoContribuinte.idPessoa =
        this.informacaoContribuinte.idPessoa || null;
      this.informacaoContribuinte.idPessoaPapel =
        this.informacaoContribuinte.idPessoaPapel || null;
      this.informacaoContribuinte.idParcelamento =
        this.informacaoContribuinte.idParcelamento || null;
      // fim
      await this.$axios
        .post(this.$env.url_backend + constantes.agrupaLancamentos, {
          informacaoContribuinte: this.informacaoContribuinte,
          acessoMinisterioPublico: this.acessoMinisterioPublico,
        })
        .then((response) => {
          const retorno = response.data;      
          const listaLancamentos = retorno[0]; 
          if (   
            listaLancamentos.LISTA_AGRUPAMENTO === null ||
            listaLancamentos.MENSAGEM_RETORNO !== "OK"
          ) {
            this.mostrarSelecaoDebitos = false;
            this.mensagem = this.verificaLinkMens(
              listaLancamentos.MENSAGEM_RETORNO
            );

            if (!this.exibeAlerteIssqnEstimativa) {
                this.mensagemErro.push(this.mensagem);
                this.listaAgrupamentos = [];
                this.carregando = false;
                window.scrollTo(0, 0);
            }
          }

          if (listaLancamentos.MENSAGEM_RETORNO === "OK") {
                const identificadorInformado =
                    // (this.origemAcesso === "GovBr" || this.origemAcesso === "AD") &&
                    // this.dadosContribuinte.tipoIdentificador === 17 &&
                    this.dadosContribuinte.identificador?.length > 0 &&  this.dadosContribuinte.tipoIdentificador !== 10;  ///---> placa veiculo
                if (identificadorInformado) {                  
                   const valido = this.lancamentoValidado(listaLancamentos.LISTA_AGRUPAMENTO);
                   if (!valido) {
                        this.carregando = false;
                        this.carregandoTabelaLancamentos = false;                    
                        if (this.origemAcesso === "GovBr") {
                           this.dadosContribuinte.nomeContribuinte =
                                   this.$store.getters.userInfo.name.toUpperCase();
                           this.dadosContribuinte.cadastroNacional =
                                   this.$store.getters.userInfo.preferred_username;                                    
                        } else if (this.origemAcesso === "AD" && this.opcaoSomenteFiltro ){
                          this.mensagemErro.push({
                            mensInicio: "Não foram encontrados débitos para esta consulta. Para emissão de CND",
                            mensLink: "https://cnd.pbh.gov.br/CNDOnline/",
                            mensFim: ""
                          });
                          window.scrollTo(0, 0); 
                          return;                                  
                        }          
                        this.carregando = false;
                        this.carregandoTabelaLancamentos = false;
                        this.codigoLancamentoParam = "";
                        this.mensagemErro.push({
                          mensInicio: "Opção de Debito Específico não pertence ao CPF/CNPJ informado",  
                          mensLink: "",
                          mensFim: "",
                        });
                        window.scrollTo(0, 0); 
                        return;
                      }
                }  
                this.mostrarSelecaoLancamentos = true;
                this.mostrarSelecaoDebitos = true;
                this.listaAgrupamentos = [];

            const lancamentos = [];
            ////  issue 689 - Guia ITBI - Alterar nome agrupamento Transação no Sisdram
            listaLancamentos.LISTA_AGRUPAMENTO.forEach(agrupamento => {
                if (agrupamento.DESCRICAO.includes("TRANSAÇÃO DE ITBI")) {
                  agrupamento.DESCRICAO = "TRANSAÇÃO DE ITBI";
                }
            });
            ////
            listaLancamentos.LISTA_AGRUPAMENTO.map((lancamento) =>
              lancamentos.push(lancamento)
            );
            this.listaAgrupamentos = lancamentos;
            this.listaNiveis = this.montaAgrupamento(lancamentos);
          }
          ////aqui
          this.carregando = false;
          this.carregandoTabelaLancamentos = false;

          if (!this.pesquisandoLancamentoUrl) {
            this.carregando = false;
            return;
          }

          this.filtrarLancamentoParametro();
        })
        .catch((err) => {
          this.carregando = false;
          this.carregandoTabelaLancamentos = false;
          const mensagem = normalizaMensagemApi(err);         
          this.mensagemErro.push({
            mensInicio: mensagem,
            mensLink: "",
            mensFim: "",
          });
          window.scrollTo(0, 0);
        });
    },

    async retornaidInclusaoTributariaItbi(lancamento){
        await this.$axios
          .post(
            this.$env.url_backend + constantes.retornaidInclusaoTributariaItbi,
            {
              lancamento: lancamento,
            }
          )
          .then((response) => {
            const retorno = response.data;
            this.idInclusaoTributariaItbi = retorno.idInclusaoTributariaItbi;
          })
          .catch(() => {
            this.exibeAlerteIssqnEstimativa = false;
          });
    },

    async lancamentoValidado(lista) {
       const cpfLogado = this.origemAcesso === "GovBr" 
                       ? this.$store.getters.userInfo.preferred_username
                       : this.dadosContribuinte.cadastroNacional;
       let localizado = false;   
       /// verifica se o codigo_nacional retornado da pesquisa no banco é o mesmo do cpf logado         
       localizado = (lista || []).some(agrup =>
          (agrup.LISTA_NIVEL2 || []).some(nivel2 =>
            (nivel2.ALANCAMENTOS || []).some(lanc =>
              String(lanc.CODIGO_NACIONAL) === String(cpfLogado)
            )
          )
        );
        if (localizado) {
            this.exibirEmpresaRelacionada = false;
            return localizado;
        }    
        if (this.origemAcesso === "GovBr") {
            /// cnpj do lancamento esta na lista de relacionados gov empresas              
            localizado = await this.verificaSeCnpjRelacionadoExiste(this.cpfCnpjLancamento);
            if (localizado) {
              this.exibirEmpresaRelacionada = true;
            }
        }
        return localizado;          
    },

    retornaCalculos: async function () {
      this.carregando = true;
      this.listaDemaisParcelamentos = [];
      this.listaCessao = [];
      this.mensagemErroFormaPagto = [];

      this.mensagemErroFormaPagto = [];
      const lancamentos = this.lancamentosSelecionados.map(
        (lancamento) => lancamento.ID_LANCAMENTO
      );

      const agrupamentos = this.lancamentosSelecionados.map(
        (lancamento) => lancamento.AGRUPAMENTO
      );

      const userName = this.userName;

      this.calculos = [];
      let calculosRetornados = {};

      await this.$axios
        .post(this.$env.url_backend + constantes.retornaCalculos, {
          lancamentosSelecionados: lancamentos,
          agrupamentoSelecionados: agrupamentos,
          usuario: userName,
          numeroProcesso: this.desconto.numeroProcesso,
          descontoSimples: this.desconto.descontoSimples,
          descontoCorrecao: this.desconto.descontoCorrecao,
          descontoJuros: this.desconto.descontoJuros,
          descontoMulta: this.desconto.descontoMulta,
          descontoSelic: this.desconto.descontoSelic,
          geraDescontoInscrito: this.desconto.geraDescontoInscrito,
          dataVencimento: this.desconto.dataVencimento,
        })
        .then((response) => {
          const retorno = response.data;
          calculosRetornados = retorno[0];
        })
        .catch((err) => {
          window.scrollTo(0, 0);
          const mensagem = normalizaMensagemApi(err);
          this.mensagemErroFormaPagto.push(mensagem);
        })
        .finally(() => {
          this.carregando = false;
        });
      //
      if (calculosRetornados[0].IDGUIA == null) {
          //  Programa Esporte para Todos
           this.limparCamposCnpjsRelacionados();
           if (calculosRetornados[0].DESCRICAO.includes("Programa Esporte para Todos"))
              msg = "Para parcelamentos do Programa Esporte para Todos deverá ser solicitado o DRAM ";
           else 
              msg = calculosRetornados[0].DESCRICAO;
           this.mensagemErro.push({
                mensInicio: msg,
                mensLink: "https://sigesp.pbh.gov.br",
                mensFim: "",
              });
            let msg = "";
            if (calculosRetornados[0].DESCRICAO.includes("Programa Esporte para Todos"))
                msg = "Para parcelamentos do Programa Esporte para Todos deverá ser solicitado o DRAM clique https://sigesp.pbh.gov.br";
            else 
                msg = calculosRetornados[0].DESCRICAO;            
            this.mensagem = this.verificaLinkMens(
              msg
            );              
           this.carregando = false;
           window.scrollTo(0, 0);
      } else {
      for (let i = 0, l = calculosRetornados.length; i < l; i++) {
        let retList = {};
        let valor = "";
        retList.IDGUIA = calculosRetornados[i].IDGUIA;
        retList.NUMEROGUIA = calculosRetornados[i].NUMEROGUIA;
        retList.DATAVENCIMENTO = calculosRetornados[i].DATAVENCIMENTO;
        retList.DESCRICAO = calculosRetornados[i].DESCRICAO;
        retList.IDGUIA = calculosRetornados[i].IDGUIA;
        retList.NUMEROGUIA = calculosRetornados[i].NUMEROGUIA;
        // busca idTransicao e idGrupo
        this.dadosTransacao.numero_transacao = "";
        this.dadosTransacao.ano_transacao = "";
        this.dadosTransacao.id_guia = retList.IDGUIA;
        valor = JSON.stringify(retList.NUMEROGUIA);
        retList.IDGRUPO = valor.substring(0, 1);
        // ---------------------------
        if (retList.IDGRUPO == 5) {
          /// issue 690 - mudar nome de grid para guia ITBI -        
          retList.DESCRICAO = calculosRetornados[i].DESCRICAO.replace("DRAM (DLDT - ITBI)","DRAM ITBI -");         
          ////  buscando o idTransacao pelo numero da guia  ////
          let id_Transacao = "";
          await this.$axios
            .post(this.$env.url_backend + constantes.buscarIDtransacaoITBI, {
              dadosTransacao: this.dadosTransacao,
            })
            .then((response) => {
              const retorno = response.data;
              id_Transacao = retorno[0].ID_INCLUSAO_TRIBUTARIA_ITBI;
            })
            .catch((err) => {
              window.scrollTo(0, 0);
              const mensagem = normalizaMensagemApi(err);
              this.mensagemErroFormaPagto.push(mensagem);
            })
            .finally(() => {
              this.carregando = false;
            });
          ////  demonstrativo de transacao de itbi  ////
          await this.$axios
            .post(this.$env.url_backend + constantes.emiteDemonstrativoITBI, {
              idTransacao: id_Transacao, ////lancamentos[i],
            })
            .then((response) => {
              const URLRELACAO = response.data.URL_IMPRESSAO;
              const mensOK = response.data.RETORNO;
              if (mensOK === "200 - EXECUCAO COM SUCESSO") {
                retList.URLRELACAO = URLRELACAO;
              }
            })
            .catch((err) => {
              this.limparCampos();
              const mensagem = normalizaMensagemApi(err);
              this.mensagemErro.push({
                mensInicio: mensagem,
                mensLink: "",
                mensFim: "",
              });
              window.scrollTo(0, 0);
            })
            .finally(() => {
              this.carregando = false;
            });
          ////  guia  ///
          retList.URLEMISSAO = calculosRetornados[i].URLEMISSAO;
          ///          
        } else {
          ////   demais guias  ////
          retList.URLEMISSAO = calculosRetornados[i].URLEMISSAO;
          retList.URLRELACAO = calculosRetornados[i].URLRELACAO;
        }
        retList.VALORDESCONTO = calculosRetornados[i].VALORDESCONTO;
        retList.VALORTOTAL = calculosRetornados[i].VALORTOTAL;
        /// quando não permite parcelar, já emite guia direto - Wagner
        if (!this.permiteParcelar && calculosRetornados.length == 1) {
          this.downloadArquivo(retList.URLEMISSAO, "emissaoDRAM");
          this.mensagemErroFormaPagto.push(
            "Existe(m) débito(s) selecionado(s) que não permite(m) parcelar."
        );          
        }
        /// ------------------------
        this.calculos.push(retList);
      }
      if (this.calculos.TLISTAURLGUIA === null)
        this.mensagemErroFormaPagto.push(
          `Falha ao gerar DRAM. Favor entrar em contato pelo e-mail gecda@pbh.gov.br`
        );
      else {
        this.exibirListaGuia = true;
         this.posicionaPagina();
      }
      }
      this.carregando = false;
    },

    retornaCalculosParcelar: async function () {
      this.carregando = true;
      this.mensagemErroFormaPagto = [];

      const lancamentos = this.lancamentosSelecionados.map(
        (lancamento) => lancamento.ID_LANCAMENTO
      );

      const agrupamentos = this.lancamentosSelecionados.map(
        (lancamento) => lancamento.AGRUPAMENTO
      );
      await this.$axios
        .post(this.$env.url_backend + constantes.retornaCalculosParcelar, {
          lancamentosSelecionados: lancamentos,
          agrupamentosSelecionados: agrupamentos,
        })
        .then((response) => {
          const retorno = response.data;
          if (retorno[0].length == 10)
            this.mensagemErroFormaPagto.push(
              `Não encontrou débito para o dado selecionado`
            );
          else {
            const calculosRetornados = retorno[0];
            this.opcoesParcelamento = calculosRetornados;
            this.listaParcelamentosCalc = [];
            let lista = [];
            this.existeParcela = false;

            lista = this.montaAgrupamentoParcto(this.opcoesParcelamento);

            for (let i = 0, l = lista.length; i < l; i++) {
              let retList = {};
              retList.lista_grupo = lista[i].lista_agrupamento;
              retList.descricao_grupo = lista[i].descricao_grupo;
              retList.lista_lancamento = lista[i].lista_lancamento;
              retList.lista_codigo_lancamento =
                lista[i].lista_codigo_lancamento;
              retList.lista_lancamento_agrupamento =
                lista[i].lista_lancamento_agrupamento;
              retList.selecionado = lista[i].selecionado;
              retList.urlGuia = lista[i].urlGuia;
              retList.urlRelatorio = lista[i].urlRelatorio;
              retList.emitido = lista[i].emitido;
              retList.lista_opcao_parcto = [];
              for (
                let x = 0, k = lista[i].lista_opcao_parcto.length;
                x < k;
                x++
              ) {
                let subnivel = {};
                if (lista[i].lista_opcao_parcto[x].AQtdParcela < 60) {
                  subnivel.APercDepositoInicial =
                    lista[i].lista_opcao_parcto[x].APercDepositoInicial;
                  subnivel.AVlrDepositoInicial =
                    lista[i].lista_opcao_parcto[x].AVlrDepositoInicial;
                  subnivel.AQtdParcela =
                    lista[i].lista_opcao_parcto[x].AQtdParcela;
                  subnivel.AQtdParcelaHonorario =
                    lista[i].lista_opcao_parcto[x].AQtdParcelaHonorario;
                  subnivel.AVlrParcela =
                    lista[i].lista_opcao_parcto[x].AVlrParcela;
                  subnivel.AVlrParcelaHonorario =
                    lista[i].lista_opcao_parcto[x].AVlrParcelaHonorario;
                  subnivel.AVlrdesconto =
                    lista[i].lista_opcao_parcto[x].AVlrdesconto;
                  subnivel.AIdTipoParcelamento =
                    lista[i].lista_opcao_parcto[x].AIdTipoParcelamento;
                  subnivel.AIdRegraParcelamento =
                    lista[i].lista_opcao_parcto[x].AIdRegraParcelamento;
                  subnivel.AIdFaixasRegraParcelamento =
                    lista[i].lista_opcao_parcto[x].AIdFaixasRegraParcelamento;
                  subnivel.adescricao =
                    lista[i].lista_opcao_parcto[x].adescricao;

                  retList.lista_opcao_parcto.push(subnivel);
                }
              }
              this.listaParcelamentosCalc.push(retList);
            }
            if (this.listaParcelamentosCalc.length > 0) {
               this.existeParcela = this.listaParcelamentosCalc[0].lista_opcao_parcto[0].AQtdParcela > 0;               
            }  
            this.exibeMensVariasOpcParc = this.existeParcela;     
            if ( !this.existeParcela ) {   /// não existe parcela, exibe mensagem
               this.posicionaPagina();
              this.exibirFormaPagamento = true;
              const msg = `ATENÇÃO: O valor total para pagamento NÃO permite
                            parcelamento devido ao valor mínimo exigido 
                            para a parcela. Utilize a opção PAGAMENTO INTEGRAL OU PARCIAL.`;
              this.mensagemErroFormaPagto.push(msg);
              this.exibirDebitos = false;
              this.exibirListaGuiaParcelar = false;
              this.debitosSelecionados = this.lancamentosSelecionados;
           
            } else {
              this.exibirListaGuia = false;
              this.exibirFormaPagamento = false;
              this.exibirListaGuiaParcelar = true;    
               this.posicionaPagina();  
            }       
            this.selecLanctosParctoTacito = [];
            this.selecGuiasParctoTacito = [];
            this.desabilitaBtnParcelar = !this.existeParcela;
          }
        })
        .catch((err) => {
          this.carregando = false;
          window.scrollTo(0, 0);
          const mensagem = normalizaMensagemApi(err);
          this.mensagemErro.push({
            mensInicio: mensagem,
            mensLink: "",
            mensFim: "",
          });
        });

      this.carregando = false;
    },

    posicionaPagina() {
        setTimeout(() => {
          window.scrollTo({ top: document.documentElement.scrollHeight, behavior: "smooth" });
        }, 500);  
    },

    enviarSMSEmissaoGuiaParcelamento: async function () {
      this.mensagemEmissaoGuiaSucesso = [];
      this.mensagemEmissaoGuia = [];
      //  buscar codigo de envio  //
      const emailConfirmacao = this.informacoesEmissaoGuia.email;
      const telefoneConfirmacao = this.informacoesEmissaoGuia.telefoneCelular;

      this.emailInformado = emailConfirmacao;
      this.telefoneInformado = telefoneConfirmacao;

      const informacaoConfirmacao = { emailConfirmacao, telefoneConfirmacao };

      await this.$axios
        .post(this.$env.url_backend + constantes.buscarCodigoConfirmacao, {
          informacaoConfirmacao,
        })
        .then((response) => {
          const retorno = response.data;
          this.informacoesEmissaoGuia.confirmacao = retorno[0];
        })
        .catch((err) => {
          const mensagem = normalizaMensagemApi(err);
          this.mensagemEmissaoGuia.push(mensagem);
          this.carregando = false;
          this.informacoesEmissaoGuia.emailEnviado = false;
        });

      const telefone = this.informacoesEmissaoGuia.telefoneCelular;
      const codigoEmissaoGuia = this.informacoesEmissaoGuia.confirmacao;
      const acesso = this.origemAcesso;
      const contribuinte = this.dadosContribuinte.nomeContribuinte;

      const informacaoEmissaoGuia = {
        telefone,
        codigoEmissaoGuia,
        acesso,
        contribuinte,
      };
      await this.$axios
        .post(
          this.$env.url_backend + constantes.enviarSMSEmissaoGuiaParcelamento,
          {
            informacaoEmissaoGuia,
          }
        )
        .then(() => {
          this.mensagemEmissaoGuiaSucesso.push("SMS enviado com sucesso!");
          this.mostrarConfirmacaoEmissaoGuia = true;
          this.informacoesEmissaoGuia.telefoneEnviado = true;
        })
        .catch((err) => {
          const mensagem = normalizaMensagemApi(err);
          this.mensagemEmissaoGuia.push(mensagem);
          this.carregando = false;
          this.informacoesEmissaoGuia.telefoneEnviado = false;
        });
    },

    enviarEmailEmissaoGuiaParcelamento: async function () {
      this.mensagemEmissaoGuia = [];
      this.mensagemEmissaoGuiaSucesso = [];
      //  buscar codigo de envio  //
      const emailConfirmacao = this.informacoesEmissaoGuia.email;
      const telefoneConfirmacao = this.informacoesEmissaoGuia.telefoneCelular;

      this.emailInformado = emailConfirmacao;
      this.telefoneInformado = telefoneConfirmacao;

      const informacaoConfirmacao = { emailConfirmacao, telefoneConfirmacao };

      await this.$axios
        .post(this.$env.url_backend + constantes.buscarCodigoConfirmacao, {
          informacaoConfirmacao,
        })
        .then((response) => {
          const retorno = response.data;
          this.informacoesEmissaoGuia.confirmacao = retorno[0];
        })
        .catch((err) => {
          const mensagem = normalizaMensagemApi(err);
          this.mensagemEmissaoGuia.push(mensagem);
          this.carregando = false;
          this.informacoesEmissaoGuia.emailEnviado = false;
        });

      const email = this.informacoesEmissaoGuia.email;
      const codigoEmissaoGuia = this.informacoesEmissaoGuia.confirmacao;

      const informacaoEmissaoGuia = { email, codigoEmissaoGuia };

      await this.$axios
        .post(
          this.$env.url_backend + constantes.enviarEmailEmissaoGuiaParcelamento,
          {
            informacaoEmissaoGuia,
          }
        )
        .then(() => {
          this.mensagemEmissaoGuiaSucesso.push("E-mail enviado com sucesso!");
          this.mostrarConfirmacaoEmissaoGuia = true;
          this.informacoesEmissaoGuia.emailEnviado = true;
        })
        .catch((err) => {
          const mensagem = normalizaMensagemApi(err);
          this.mensagemEmissaoGuia.push(mensagem);
          this.carregando = false;
          this.informacoesEmissaoGuia.emailEnviado = false;
        });
    },

    emitirGuiaParcelamento: async function () {
      this.mensagemParcelamento = [];

      const email = this.informacaoParcelamento.email;
      const telefone = this.informacaoParcelamento.telefone;
      const usuario = this.userName;

      const opcaoParctoInternaSelecionada =
        this.escolhaOpcaoParcelamentoInterna;

      if (opcaoParctoInternaSelecionada) {
        const lancamentos = this.lancamentosSelecionados.map(
          (lancamento) => lancamento.ID_LANCAMENTO
        );

        const informacaoGuia = {
          lancamentos,
          email,
          telefone,
          idOperadorSistema: 0,
          selecao: opcaoParctoInternaSelecionada,
          usuario,
        };

        this.guiaParcelamento(informacaoGuia);
      }
    },

    limparCamposEmissaoGuia: function () {
      this.informacoesEmissaoGuia.listaParcelamento = [];

      this.informacoesEmissaoGuia.cpfCnpj = "";
      this.informacoesEmissaoGuia.razaoSocial = "";
      this.informacoesEmissaoGuia.telefoneCelular = "";
      this.informacoesEmissaoGuia.telefoneEnviado = false;
      this.informacoesEmissaoGuia.email = "";
      this.informacoesEmissaoGuia.emailEnviado = false;
      this.mensagemLancamentos = [];
      this.mostrarConfirmacaoEmissaoGuia = false;
      this.informacoesEmissaoGuia.codigoEmissaoGuia = "";

      this.mensagemEmissaoGuia = [];
      this.mensagemEmissaoGuiaSucesso = [];
    },

    autenticarEmissao: function () {
      this.carregando = true;
      this.mensagemEmissaoGuia = [];

      this.informacoesEmissaoGuia.cpfCnpj =
        this.informacaoContribuinte.cadastroNacional;

      this.informacoesEmissaoGuia.razaoSocial =
        this.informacaoContribuinte.nome;

      this.carregando = false;
    },

    confirmarEmissaoGuia: async function () {
      this.carregando = true;
      this.mensagemEmissaoGuia = [];
      const lancamentosEmissaoGuia = this.lancamentosEmissaoGuia.map(
        (lancamento) => lancamento.ID_LANCAMENTO
      );

      const informacaoEmissaoGuia = { lancamentosEmissaoGuia };

      await this.$axios
        .post(this.$env.url_backend + constantes.confirmarEmissaoGuia, {
          informacaoEmissaoGuia,
        })
        .then((response) => {
          const retorno = response.data[0];

          this.informacoesEmissaoGuia.cpfCnpj =
            this.informacaoContribuinte.cadastroNacional;

          this.informacoesEmissaoGuia.razaoSocial =
            this.informacaoContribuinte.nome;
          if (retorno.AMENSAGEM === "OK") {
            this.informacoesEmissaoGuia.confirmacao = retorno.ACONFIRMACAO;
            this.informacoesEmissaoGuia.dadosExibicao = retorno.ADADOSEXIBICAO;
            this.informacoesEmissaoGuia.listaParcelamento =
              retorno.ALISTAPARCTOS;
            this.carregando = false;
          } else {
            this.mensagemEmissaoGuia.push(response.data.AMENSAGEM);
            this.carregando = false;
          }
        })
        .catch(() => {
          this.carregando = false;
          this.mostrarConfirmacaoEmissaoGuia = false;
        });
    },

    exibirGuiaParcelamentoTacito: async function () {
      for (let i = 0, l = this.selecGuiasParctoTacito.length; i < l; i++) {
        this.dadosGuiaParcelamentoTacito.pidtipoEmissao = 4;
        this.dadosGuiaParcelamentoTacito.pidoperadorsistema = null;
        this.dadosGuiaParcelamentoTacito.pqtdparcelas =
          this.selecGuiasParctoTacito[i].pqtdparcelas;
        this.dadosGuiaParcelamentoTacito.pvalorparcela =
          this.selecGuiasParctoTacito[i].pvalorparcela;
        this.dadosGuiaParcelamentoTacito.pvalordeposito =
          this.selecGuiasParctoTacito[i].pvalordeposito;
        this.dadosGuiaParcelamentoTacito.ppercdeposito =
          this.selecGuiasParctoTacito[i].ppercdeposito;
        this.dadosGuiaParcelamentoTacito.pidregraparcelamento =
          this.selecGuiasParctoTacito[i].pidregraparcelamento;
        this.dadosGuiaParcelamentoTacito.pidfaixasregras =
          this.selecGuiasParctoTacito[i].pidfaixasregras;
        this.selecGuiasParctoTacito.map((guia) => {
          guia.plancamentos.map((lancamento) => {
            this.dadosGuiaParcelamentoTacito.pListaLancamentos.push(lancamento);
          });
        });
        this.selecGuiasParctoTacito.map((guia) => {
          guia.pagrupamentos.map((agrupamento) => {
            this.dadosGuiaParcelamentoTacito.pListaAgrupamentos.push(
              agrupamento
            );
          });
        });
        this.dadosGuiaParcelamentoTacito.pemail = this.emailInformado;
        this.dadosGuiaParcelamentoTacito.ptelefone = this.telefoneInformado;
        this.dadosGuiaParcelamentoTacito.pusuario = this.userName;
        // emite a guia
        this.carregando = true;
        this.limparMensagensDeErro();

        await this.$axios
          .post(
            this.$env.url_backend + constantes.emiteGuiaParcelamentoTacito,
            {
              dadosGuiaParcelamentoTacito: this.dadosGuiaParcelamentoTacito,
            }
          )
          .then((response) => {
            const retorno = response.data;
            const urlGuia = retorno[0].AURLEMISSAO;
            const mensOK = retorno[0].AMENSAGEM;
            if (mensOK === "OK") {
              this.downloadArquivo(urlGuia, "emissaoDRAM");
            }
            this.carregando = false;
          })
          .catch((err) => {
            this.limparCampos();
            this.carregando = false;
            const mensagem = normalizaMensagemApi(err);
            this.mensagemErro.push({
              mensInicio: mensagem,
              mensLink: "",
              mensFim: "",
            });
            window.scrollTo(0, 0);
          });
        //
        this.dadosGuiaParcelamentoTacito = {
          pidtipoEmissao: 0,
          pidoperadorsistema: null,
          pqtdparcelas: 0,
          pvalorparcela: 0,
          pvalordeposito: 0,
          ppercdeposito: 0,
          pidregraparcelamento: 0,
          pidfaixasregras: 0,
          pListaLancamentos: [],
          pemail: "",
          ptelefone: "",
          pusuario: "",
        };
      }
    },

    exibirGuiaParcelamentoTacitoEmLista: async function () {
      let pos = 0;
      let demonstrativoTransacaoITBI = false;
      for (let i = 0, l = this.selecGuiasParctoTacito.length; i < l; i++) {
        pos = this.selecGuiasParctoTacito[i].id;
        this.dadosGuiaParcelamentoTacito.pidtipoEmissao = 4;
        this.dadosGuiaParcelamentoTacito.pidoperadorsistema = null;
        this.dadosGuiaParcelamentoTacito.pqtdparcelas =
          this.selecGuiasParctoTacito[i].pqtdparcelas;
        this.dadosGuiaParcelamentoTacito.pvalorparcela =
          this.selecGuiasParctoTacito[i].pvalorparcela;
        this.dadosGuiaParcelamentoTacito.pvalordeposito =
          this.selecGuiasParctoTacito[i].pvalordeposito;
        this.dadosGuiaParcelamentoTacito.ppercdeposito =
          this.selecGuiasParctoTacito[i].ppercdeposito;
        this.dadosGuiaParcelamentoTacito.pidregraparcelamento =
          this.selecGuiasParctoTacito[i].pidregraparcelamento;
        this.dadosGuiaParcelamentoTacito.pidfaixasregras =
          this.selecGuiasParctoTacito[i].pidfaixasregras;
        if (this.selecGuiasParctoTacito[i].pqtdparcelas !== 0) {
          if (this.selecGuiasParctoTacito[i].plancamentos.length > 0)
            this.dadosGuiaParcelamentoTacito.pListaLancamentos =
              this.selecGuiasParctoTacito[i].plancamentos;
          else this.dadosGuiaParcelamentoTacito.pListaLancamentos = [];
          if (this.listaParcelamentosCalc[i].lista_grupo.length > 0) {
            this.dadosGuiaParcelamentoTacito.pListaAgrupamentos =
              this.selecGuiasParctoTacito[i].pagrupamentos;
            demonstrativoTransacaoITBI =
              this.selecGuiasParctoTacito[i].pagrupamentos[0] == 5;
          } else this.dadosGuiaParcelamentoTacito.pListaAgrupamentos = [];
        }
        this.dadosGuiaParcelamentoTacito.pemail = this.emailInformado;
        this.dadosGuiaParcelamentoTacito.ptelefone = this.telefoneInformado;
        this.dadosGuiaParcelamentoTacito.pusuario = this.userName;
        // emite a guia
        this.carregando = true;
        this.limparMensagensDeErro();

        if (demonstrativoTransacaoITBI) {
          ////  demonstrativo de transacao de itbi  ////
          await this.$axios
            .post(this.$env.url_backend + constantes.emiteDemonstrativoITBI, {
              idTransacao:
                this.dadosGuiaParcelamentoTacito.pListaLancamentos[0],
            })
            .then((response) => {
              const urlRelatorio = response.data.URL_IMPRESSAO;
              const mensOK = response.data.RETORNO;
              if (mensOK === "200 - EXECUCAO COM SUCESSO") {
                this.listaParcelamentosCalc[i].urlRelatorio = urlRelatorio;
              }
              this.carregando = false;
            })
            .catch((err) => {
              this.limparCampos();
              this.carregando = false;

              const mensagem = normalizaMensagemApi(err);
              this.mensagemErro.push({
                mensInicio: mensagem,
                mensLink: "",
                mensFim: "",
              });
              window.scrollTo(0, 0);
            });
          ////  guia parcelamento  ////
          await this.$axios
            .post(
              this.$env.url_backend + constantes.emiteGuiaParcelamentoTacito,
              {
                dadosGuiaParcelamentoTacito: this.dadosGuiaParcelamentoTacito,
              }
            )
            .then((response) => {
              const retorno = response.data;
              const urlGuia = retorno[0].AURLEMISSAO;
              const mensOK = retorno[0].AMENSAGEM;
              if (mensOK === "OK") {
                this.listaParcelamentosCalc[pos].urlGuia = urlGuia;
              }
              this.carregando = false;
            })
            .catch((err) => {
              this.limparCampos();
              this.carregando = false;

              const mensagem = normalizaMensagemApi(err);
              this.mensagemErro.push({
                mensInicio: mensagem,
                mensLink: "",
                mensFim: "",
              });
              window.scrollTo(0, 0);
            });
          ///
        } else {
          ////   demais guias  ////
          await this.$axios
            .post(
              this.$env.url_backend + constantes.emiteGuiaParcelamentoTacito,
              {
                dadosGuiaParcelamentoTacito: this.dadosGuiaParcelamentoTacito,
              }
            )
            .then((response) => {
              const retorno = response.data;
              const urlGuia = retorno[0].AURLEMISSAO;
              const urlRelatorio = retorno[0].AURLRELATORIO;
              const mensOK = retorno[0].AMENSAGEM;
              if (mensOK === "OK") {
                this.listaParcelamentosCalc[pos].urlGuia = urlGuia;
                this.listaParcelamentosCalc[pos].urlRelatorio = urlRelatorio;
              }
              this.carregando = false;
            })
            .catch((err) => {
              this.limparCampos();
              this.carregando = false;

              const mensagem = normalizaMensagemApi(err);
              this.mensagemErro.push({
                mensInicio: mensagem,
                mensLink: "",
                mensFim: "",
              });
              window.scrollTo(0, 0);
            });
        }

        this.dadosGuiaParcelamentoTacito = {
          pidtipoEmissao: 0,
          pidoperadorsistema: null,
          pqtdparcelas: 0,
          pvalorparcela: 0,
          pvalordeposito: 0,
          ppercdeposito: 0,
          pidregraparcelamento: 0,
          pidfaixasregras: 0,
          pListaLancamentos: [],
          pListaAgrupamentos: [],
          pemail: "",
          ptelefone: "",
          pusuario: "",
        };
      }
    },

    finalizarEmissaoGuia: async function () {
      this.mensagemEmissaoGuia = [];
      this.mensagemEmissaoGuiaSucesso = [];
      this.bloquearExibirLancamentos = false;

      if (this.origemAcesso === "GovBr") {
        this.exibirGuiaParcelamentoTacito();
        this.fecharModal("modal-EmissaoGuia");
        this.bloqueioEmissaoGuia = false;
        this.desabilitarAba("selecaoDebito");
      } else {
        if (
          this.informacoesEmissaoGuia.codigoEmissaoGuia ===
          this.informacoesEmissaoGuia.confirmacao
        ) {
          this.exibirGuiaParcelamentoTacito();
          this.fecharModal("modal-EmissaoGuia");
          this.bloqueioEmissaoGuia = false;
          this.desabilitarAba("selecaoDebito");
        } else {
          this.mensagemEmissaoGuia.push("O código inserido está incorreto.");
          this.carregando = false;
          this.informacoesEmissaoGuia.emailEnviado = true;
        }
      }
    },

    finalizarEmissaoGuiaEmLista: async function () {
      this.mensagemEmissaoGuia = [];
      this.mensagemEmissaoGuiaSucesso = [];
      this.bloquearExibirLancamentos = false;
      if (this.origemAcesso === "GovBr" || !this.somenteParcelado) {
        this.exibirGuiaParcelamentoTacitoEmLista();
        this.fecharModal("modal-EmissaoGuia");
        this.bloqueioEmissaoGuia = false;
        this.bloqueiaOpcao = true;
      } else {
        if (
          this.informacoesEmissaoGuia.codigoEmissaoGuia ===
          this.informacoesEmissaoGuia.confirmacao
        ) {
          this.exibirGuiaParcelamentoTacitoEmLista();
          this.fecharModal("modal-EmissaoGuia");
          this.bloqueioEmissaoGuia = false;
          this.bloqueiaOpcao = true;
        } else {
          this.mensagemEmissaoGuia.push("O código inserido está incorreto.");
          this.carregando = false;
          this.informacoesEmissaoGuia.emailEnviado = true;
        }
      }
    },

    guiaParcelamento: async function (informacaoGuia) {
      this.mensagemParcelamento = [];
      this.carregando = true;   
      await this.$axios
        .post(this.$env.url_backend + constantes.retornaGuiaParcelamentos, {
          informacaoGuia,
        })
        .then((response) => {
          const retorno = response.data;
          if (retorno[0].AMENSAGEM === "OK") {
            const url = retorno[0].AURLEMISSAO;

            this.downloadArquivo(url, "emissaoDRAM");
            this.carregando = false;
          } else {
            this.mensagemParcelamento.push(
              "Houve um erro ao gerar o DRAM de parcelamento."
            );
            this.carregando = false;
          }
        })
        .catch((err) => {
          this.carregando = false;
          this.fecharModal("modal-parcelamento");
          window.scrollTo(0, 0);
          const mensagem = normalizaMensagemApi(err);
          this.mensagemParcelamento.push(mensagem);
        });
    },

    simularPagamento: async function () {
      this.mensagemErro = [];

      this.carregando = true;

      const lancamentos = this.lancamentosSelecionados.map(
        (lancamento) => lancamento.ID_LANCAMENTO
      );

      await this.$axios
        .post(this.$env.url_backend + constantes.imprimeSimulacao, {
          lancamentosSelecionados: lancamentos,
        })
        .then((response) => {
          const retorno = response.data;
          const url = retorno[0];
          const link = url;

          this.downloadArquivo(link, "emissaoDRAM");
          this.carregando = false;
        })
        .catch((err) => {
          const mensagem = normalizaMensagemApi(err);
          this.mensagemErro.push({
            mensInicio: mensagem,
            mensLink: "",
            mensFim: "",
          });
          this.fecharModal("modal-lancamentos");
          window.scrollTo(0, 0);
          this.carregando = false;
        });
    },

    f(url, ind1) {
      const str1 = ind1;
      this.chaveID = `${str1}`;

      const ind = this.btnSelecionadosParcelamento.findIndex(
        (e) => e.id === this.chaveID
      );

      // se já foi clicado ( existe na lista), remove
      if (ind !== -1) {
        this.btnSelecionadosParcelamento =
          this.btnSelecionadosParcelamento.filter(
            (item) => item.id != this.chaveID
          );
      } // inclui ( clicado )
      else {
        this.btnSelecionadosParcelamento.push({ id: this.chaveID });
        const link = url;

        this.downloadArquivo(link, "emissaoDRAM");
      }
    },

    limparDadosTabela: function () {
      this.limparInformacoesTabela();
      this.lancamentosSelecionados = [];
      this.lancamentosEmissaoGuia = [];
      this.lancamentos = [];
      this.calculos = {};
    },

    limparInformacoesTabela: function () {
      this.permitirCancelar = false;
      this.bloqueioEmissaoGuia = false;
    },

    leftPad: function (value, totalWidth, paddingChar) {
      let length = totalWidth - value.toString().length + 1;
      return Array(length).join(paddingChar || "0") + value;
    },

    montaMascara: function (value) {
      if (!value) return "####################";
      let bar = "/";
      let maskedNumber = value.padStart(value.length, "*");
      let position = maskedNumber.length - 4;
      let output = [
        maskedNumber.slice(position),
        bar,
        maskedNumber.slice(position),
      ].join("");
      return output;
    },

    retornaBarra: function (value) {
      let bar = "/";
      let position = value.length - 4;
      let output = [value.slice(0, position), bar, value.slice(position)].join(
        ""
      );
      return output;
    },

    formatGuia: function (value) {
      if (!value) return "";
      else {
        let valor = value;
        valor = this.leftPad(valor, 13);
        valor = valor.replace(/(\d{2})(\d{2})(\d{7})(\d{2})$/, "$1.$2.$3.$4");
        return valor;
      }
    },

    formatDateTime: function (value) {
      if (!value) return "";
      else return moment(String(value)).format("DD/MM/YYYY");
    },

    formatCurrency: function (value) {
      if (value != null) {
        let formatter = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        });
        return formatter.format(value);
      } else {
        return "______";
      }
    },

    formatCPFCNPJ(value) {
      if (value === "0") return "Identificador não encontrado";
      if (!value) return "";
      else {
        value = value.replace(/[^a-zA-Z0-9]+/g, "");

        if (value.length === 11) {
          value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
          return value;
        } else if (value.length === 14) {
          value = value.replace(
            /(\w{2})(\w{3})(\w{3})(\w{4})(\w{2})$/,
            "$1.$2.$3/$4-$5"
          );
          return value;
        }
      }
    },

    preenchePlaceHolderIdentificador() {
      const placeholders = {
        1: "Informe a Inscrição Municipal",
        3: "Informe o CPF",
        4: "Informe o CNPJ",
        5: "Informe a Perpetuidade",
        8: "Informe o Índice Cadastral",
        10: "Informe a Placa do Veículo",
        14: "Informe o Parcelamento / ano",
        15: "Informe o Processo Judicial",
        16: "Informe a Transação de ITBI / ano",
        17: "Informe o Lançamento",
      };

      this.placeHolderIdentificador =
        placeholders[this.dadosContribuinte.tipoIdentificador] || "";
    }, 

    reinicializaIdentificador: function () {
      this.mensagemErro = [];
      this.cnpjsRelacionadosTabelaBkp = this.cnpjsRelacionadosTabela ;
      this.cnpjsRelacionadosTabela = [];
      this.mensagemValidacaoIdentificador = "";
      this.preencheIdentificadorOK = false;
      this.cnpjRelacionadoFoiSelecionado = true;
      this.mostrarListagemCnpj = true;
      this.mostrarSelecaoDebitos = false;
      this.dadosContribuinte.codigoLancamento = "";
      this.dadosContribuinte.identificador = "";
      this.dadosContribuinte.numeroParcelamento = "";
      this.dadosContribuinte.placaVeiculo = "";
      this.dadosContribuinte.processoJudicial = "";
      this.dadosContribuinte.transacao = "";      
      if (this.origemAcesso === "GovBr") {
          this.habilitaDesabilitaCnpjCpf = true;                 
      }
      else {
          if (this.dadosContribuinte.cadastroNacional == "") 
              this.dadosContribuinte.nomeContribuinte = "";
          this.habilitaDesabilitaCnpjCpf = false;
      } 
      
      this.preenchePlaceHolderIdentificador();

      this.dadosContribuinte.identificador = "";
      this.mascaraIdentificador = {};
      this.habilitarCampos();
      this.focusInput("identificador");
    },

    getDebitosSelecionados(data) {
      this.orgaoCobranca = data && typeof data === "object" ? data : [];

      this.limparDadosTabela();
      this.lancamentos = [];
      this.calculos = {};

      this.orgaoCobranca.map((orgao) => {
        orgao.ALANCAMENTOS.map((lancamento) => {
          this.lancamentos.push(lancamento);
        });
      });
    },

    getSelecionados(data) {
      if (data.title === "lancamentos") {
        this.lancamentosSelecionados = data.selecionados;       
        this.permiteParcelar = data.permiteParcelamento;
        /// verifica se tem tributo "ISSQN fONTE - RETIDO" pois não permite parcelar
        // const existeIssqnRetido = this.lancamentosSelecionados.some(item =>
        //                               item.DESCRICAO_LANCAMENTO?.includes("ISSQN FONTE - RETIDO")
        //                             );
        // this.permiteParcelar = !existeIssqnRetido;                            
        this.existePrescrito = data.existePrescrito;
        this.permiteConcederDesconto = false;
      }

      if (data.title === "emitirParcelamentosTacitos") {        
        this.selecGuiasParctoTacito = data.selecionados;
        this.mensagemEmissaoGuia = [];
        this.mensagemEmissaoGuiaSucesso = [];

        this.somenteParcelado = false;
        this.mensagemErro = [];

        if (this.selecGuiasParctoTacito.length === 0) {
          this.carregando = false;
          this.mensagemErro.push({
            mensInicio: "Selecione pelo menos um parcelamento.",
            mensLink: "",
            mensFim: "",
          });
          window.scrollTo(0, 0);
        } else {
          for (let i = 0, l = this.selecGuiasParctoTacito.length; i < l; i++) {
            if (
              this.selecGuiasParctoTacito[i].pqtdparcelas > 0 &&
              this.selecGuiasParctoTacito[i].adescricao === ""
            ) {
              this.somenteParcelado = true;
            }
          }
          if (this.origemAcesso === "GovBr" || this.origemAcesso === "AD") {
            this.autenticarEmissao();
            this.finalizarEmissaoGuiaEmLista();
          } else {
            if (!this.somenteParcelado) {
              this.finalizarEmissaoGuiaEmLista();
            } else {
              this.abrirModal("modal-EmissaoGuia");
            }
          }
        }
      }

      if (data.title === "fecharParcelamentosTacitos") {
        this.exibirFormaPagamento = true;
         this.posicionaPagina();
        this.bloqueiaOpcao = false;
        this.fecharGuiasParcelar();
      }
    },

    desabilitarCampos() {},

    habilitarCampos() {
      this.desabilitacodigoNacional = false;
      this.desabilitanomeContribuinte = false;
      this.desabilitaNome = false;
      this.desabilitaIdentificador = false;
      this.desabilitaParcelamento = false;
      this.bloquearExibirLancamentos = false;
    },

    limparMensagensDeErro() {
      this.mensagemErro = [];
      this.mensagemLancamentos = [];

      this.mensagemParcelamento = [];
      this.mostrarMensagemDebitosInexistentes = false;

      this.erroValidacaoCPFCNPJ = "";
      this.mensagemValidacaoCPFCNPJ = "";

      this.erroValidacaoIdentificador = "";
      this.mensagemValidacaoIdentificador = "";

      this.erroValidacaoParcelamento = "";
      this.mensagemValidacaoParcelamento = "";

      this.erroValidacaoCodigoParcelamento = "";
      this.mensagemValidacaoCodigoParcelamento = "";

      this.erroValidacaoPlacaVeiculo = "";
      this.mensagemValidacaoPlacaVeiculo = "";

      this.erroValidacaoLancamento = "";
      this.mensagemValidacaoLancamento = "";
    },

    limparCamposParcelamento: function () {
      this.mensagemParcelamento = [];

      this.escolhaDemaisParcelamentos = "";
      this.mostrarDemais = false;

      this.escolhaCessao = "";
      this.mostrarCessao = false;

      this.informacaoParcelamento.email = "";
      this.informacaoParcelamento.telefone = "";
      this.bloquearExibirLancamentos = false;
    },

    abrirModal: function (referencia) {
      this.$refs[referencia].show();
    },

    formataParcelamentoTransacao: function (valor) {
      valor = valor + "";
      valor = parseInt(valor.replace(/[\D]+/g, ""));
      valor = valor + "";
      if (valor.length > 4) {
        valor = valor.replace(/([0-9]{4})$/g, "/$1");
      }
      if (valor == "NaN") {
        valor = "";
      }
      return valor;
    },

    preencheIdentificador: async function () {
      let tam = 0;
      let mensErro = "";
      let textColor = "";
      let opcao = "";
      if (this.dadosContribuinte.identificador.length > 0) {
        //inscrição municipal
        if (this.dadosContribuinte.tipoIdentificador === 1) {
          tam = 15;
          opcao = "INSCRIÇÃO MUNICIPAL";
        }
        //CPF
        if (this.dadosContribuinte.tipoIdentificador === 3) {
          tam = 14;
          opcao = "CPF";
        }
        //CNPJ
        if (this.dadosContribuinte.tipoIdentificador === 4) {
          tam = 18;
          opcao = "CNPJ";
        }
        //perpetuidade
        if (this.dadosContribuinte.tipoIdentificador === 5) {
          tam = 2;
          opcao = "PERPETUIDADE";
        }
        //PARCELAMENTO
        if (this.dadosContribuinte.tipoIdentificador === 14) {
          tam = 5;
          opcao = "PARCELAMENTO";
          this.dadosContribuinte.identificador =
            this.formataParcelamentoTransacao(
              this.dadosContribuinte.identificador
            );
        }
        //PROCESSO JUDICIAL
        if (this.dadosContribuinte.tipoIdentificador === 15) {
          tam = 20;
          opcao = "PROCESSO JUDICIAL";
        }
        //ÍNDICE CADASTRAL
        if (this.dadosContribuinte.tipoIdentificador === 8) {
          tam = 19;
          opcao = "ÍNDICE CADASTRAL";
        }
        //PLACA DE VEÍCULO
        if (this.dadosContribuinte.tipoIdentificador === 10) {
          tam = 8;
          opcao = "PLACA DE VEÍCULO";
        }
        //LANCAMENTO
        if (this.dadosContribuinte.tipoIdentificador === 17) {
          tam = 14;
          opcao = "LANÇAMENTO";
        }
        //TRANSAÇAO
        if (this.dadosContribuinte.tipoIdentificador === 16) {
          tam = 5;
          opcao = "TRANSAÇÃO";
          this.dadosContribuinte.identificador =
            this.formataParcelamentoTransacao(
              this.dadosContribuinte.identificador
            );
        }

        if (this.dadosContribuinte.tipoIdentificador === 16) {
          mensErro =
            this.dadosContribuinte.identificador.length >= tam
              ? opcao + " digitada é válida"
              : opcao + " digitada está incompleta";
        } else {
          mensErro =
            this.dadosContribuinte.identificador.length >= tam
              ? opcao + " digitado(a) é válido(a)"
              : opcao + " digitado(a) está incompleto(a)";
        }
        textColor =
          this.dadosContribuinte.identificador.length >= tam
            ? "text-success"
            : "text-danger";
        this.preencheIdentificadorOK =
          this.dadosContribuinte.identificador.length >= tam;
        if (this.dadosContribuinte.identificador.length >= tam) {
          // inscricao municipal
          if (this.dadosContribuinte.tipoIdentificador === 1) {
            if (
              this.validarInscricaoMunicipal(
                this.dadosContribuinte.identificador
              )
            ) {
              mensErro = opcao + " digitado(a) é válido(a)";
              textColor = "text-success";
              this.preencheIdentificadorOK = true;
            } else {
              mensErro = opcao + " - dígito verificador inválido";
              textColor = "text-danger";
              this.preencheIdentificadorOK = false;
            }
          }
          // indice cadastral
          if (this.dadosContribuinte.tipoIdentificador === 8) {
            if (this.validarIPTU(this.dadosContribuinte.identificador)) {
              mensErro = opcao + " digitado(a) é válido(a)";
              textColor = "text-success";
              this.preencheIdentificadorOK = true;
            } else {
              mensErro = opcao + " - dígito verificador inválido";
              textColor = "text-danger";
              this.preencheIdentificadorOK = false;
            }
          }
          // lancamento
          if (this.dadosContribuinte.tipoIdentificador === 17) {
            if (this.dadosContribuinte.identificador.length >= tam) {
              this.cpfCnpjLancamento = await this.validarLancamento(this.dadosContribuinte.identificador);
              if (this.cpfCnpjLancamento != null) {
                mensErro = opcao + " digitado é válido";
                textColor = "text-success";
                this.preencheIdentificadorOK = true;
              } else {
                mensErro = opcao + " digitado não existe na base de dados";
                textColor = "text-danger";
                this.preencheIdentificadorOK = false;
              }
            } else {
              mensErro = opcao + " - digitado é inválido";
              textColor = "text-danger";
              this.preencheIdentificadorOK = false;
            }
          }
          // cnpj
          if (this.dadosContribuinte.tipoIdentificador === 4) {
            if (validarCNPJ(this.dadosContribuinte.identificador)) {
              mensErro = opcao + " digitado(a) é válido(a)";
              textColor = "text-success";
              this.preencheIdentificadorOK = true;
            } else {
              mensErro = opcao + " - dígito verificador inválido";
              textColor = "text-danger";
              this.preencheIdentificadorOK = false;
            }
          }
          // cpf
          if (this.dadosContribuinte.tipoIdentificador === 3) {
            if (validarCPF(this.dadosContribuinte.identificador)) {
              mensErro = opcao + " digitado(a) é válido(a)";
              textColor = "text-success";
              this.preencheIdentificadorOK = true;
            } else {
              mensErro = opcao + " - dígito verificador inválido";
              textColor = "text-danger";
              this.preencheIdentificadorOK = false;
            }
          }
        }
        // this.desabilitaBtnPesquisar = !this.preencheIdentificadorOK;    
        this.desabilitarCampos();
        this.erroValidacaoIdentificador = textColor;
        this.mensagemValidacaoIdentificador = mensErro;
      }
      if (this.dadosContribuinte.identificador === "") {
        this.mensagemValidacaoIdentificador = "";
      }
      if (this.dadosContribuinte.cadastroNacional === "") {
        this.mensagemValidacaoCPFCNPJ = "";
      }
    },

    validacaoIdentificador: function () {
      if (this.dadosContribuinte.tipoIdentificador === 1) {
        //inscrição municipal
        this.mascaraIdentificador = {
          mask: "#.###.###/###-J",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 3) {
        // CPF
        this.mascaraIdentificador = {
          mask: "###.###.###-##",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 4) {
        // CNPJ
        this.mascaraIdentificador = {
          mask: "XX.XXX.XXX/XXXX-##",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 5) {
        // PERPETUIDADE
        this.mascaraIdentificador = {
          mask: "##############",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 17) {
        // LANCAMENTO
        this.mascaraIdentificador = {
          mask: "XXXXXXXXXXXXXX",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 15) {
        // PROCESSO JUDICIAL
        this.mascaraIdentificador = {
          mask: "####################",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 14) {
        // PARCELAMENTO
        this.mascaraIdentificador = {
          mask: "#######/####",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 8) {
        // INDICE CADASTRAL
        this.mascaraIdentificador = {
          mask: "###.###E.###E.X##.J",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 10) {
        // PLACA DE VEICULO
        this.mascaraIdentificador = {
          mask: "LLL-#X##",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 16) {
        // TRANSACAO
        this.mascaraIdentificador = {
          mask: "#######/####",
          tokens: this.tokens,
        };
      }
      this.desabilitarCampos();
    },

    validacaoParcelamento: function () {
      const anoAtual = new Date().getFullYear();
      const numeroParcelamento = this.dadosContribuinte.numeroParcelamento;
      const anoParcelamento = numeroParcelamento.substring(
        8,
        numeroParcelamento.length
      );

      let mensErro = "";
      let textColor = "";

      if (anoParcelamento > anoAtual) {
        mensErro =
          "O ano em que foi feito o parcelamento não pode ser maior que o ano atual";
        textColor = "text-danger";
      }

      this.desabilitarCampos();
      this.erroValidacaoParcelamento = textColor;
      this.mensagemValidacaoParcelamento = mensErro;
    },

    validacaoCodigoParcelamento: function () {
      this.erroValidacaoCodigoParcelamento = "";
      this.mensagemValidacaoCodigoParcelamento = "";
    },

    validacaoPlacaVeiculo: function () {
      this.erroValidacaoPlacaVeiculo = "";
      this.mensagemValidacaoPlacaVeiculo = "";
    },

    validacaoLancamento: function () {
      this.erroValidacaoLancamento = "";
      this.mensagemValimparCampospesquisartlidacaoLancamento = "";
    },

    resetCampos: function () {
      if (this.origemAcesso !== "GovBr") {
        this.cnpjsSelecionado = "";
        this.dadosContribuinte.nomeContribuinte = "";
        this.habilitaDesabilitaCnpjCpf = false;
        this.dadosContribuinte.cpf = "";
        this.dadosContribuinte.cadastroNacional = "";
        this.dadosContribuinte.limparCamposcadastroNacional = "";
      } else if (this.origemAcesso === "GovBr") {
        this.cnpjsSelecionado = "";
        this.dadosContribuinte.nomeContribuinte = this.origemNome.toUpperCase();
      }
      this.dadosContribuinte.razaoSocial = "";
      this.dadosContribuinte.tipoIdentificador = 0;
      this.dadosContribuinte.codigoLancamento = "";
      this.dadosContribuinte.identificador = "";
      this.dadosContribuinte.numeroParcelamento = "";
      this.dadosContribuinte.placaVeiculo = "";
      this.dadosContribuinte.processoJudicial = "";
      this.dadosContribuinte.transacao = "";
    },

    inicializarCampos: function () {
      this.limparMensagensDeErro();
      this.desabilitarAba("all");
      this.bloqueiaOpcao = false;
      this.mostrarMensagemDebitosInexistentes = false;
      this.mostrarDemaisInformacoes = false;
      this.mostrarErroMuitosLancamentos = false;
      this.exibirDebitosSelecionados = false;

      this.mostrarSelecaoDebitos = false;
      this.exibirDebitos = false;
      this.exibirListaGuia = false;
      this.exibeBotaoPesquisar = false;
      this.refazerAgrupamento = false;

      this.calculos = {
        OPCOES_PARCTO_CESSAO: [],
        OPCOES_PARCTO_DEMAIS: [],
        LANCAMENTO_CESSAO: [],
        LANCAMENTO_DEMAIS: [],
      };

      this.habilitarCampos();
    },

    limparCamposConcessaoDesconto: function () {
      this.juros = "";
      this.multa = "";
      this.correcao = "";
      this.selic = "";
      this.processoConcessaoDesconto = "";
      this.venctoConcessaoDesconto = null;
    },

    async limparCamposCnpjsRelacionados() {
      // this.pesquisando =false;
      this.cnpjsRelacionadosTabela = this.cnpjsRelacionadosTabelaBkp;
      this.mostrarListagemCnpj = true;
      this.cnpjRelacionadoFoiSelecionado = false;
      this.desabilitaNome = false;
      this.desabilitaIdentificador = false;
      // this.desabilitaBtnPesquisar = true;
      // dá um toggle na variavel para forçar o componente filho a atualizar
      this.forcaLimparCamposListagemCnpj = !this.forcaLimparCamposListagemCnpj;
      this.limparCamposEmpresaRelacionada();
      this.limparCampos();
      this.preencheCpfCnpjOK = true;
      await this.buscarCNPJSRelacionados();       
      const focoID = this.origemAcesso === "AD" ? "cpfCnpj" : "opcaoIdentificador";
      this.$nextTick(() => {this.focusInput(focoID); });     
    },

    limparCamposEmpresaRelacionada(){
      this.cnpj.nome = "";
      this.cnpj.valor = "";
      this.exibirEmpresaRelacionada = false;
    }, 

    limparCampos: async function () {
      this.resetCampos();
      this.inicializarCampos();
      this.usuarioClicouEmPesquisar = false;
      this.desabilitaNome = false;

      this.exibeAlerteIssqnEstimativa = false;
      this.mostrarListagemCnpj = true;
      if (this.origemAcesso === "GovBr") {
        this.dadosContribuinte.cadastroNacional =
          this.$store.getters.userInfo.preferred_username;
        if (this.dadosContribuinte.cadastroNacional.length === 11) {
          this.dadosContribuinte.cadastroNacional = formatador.formataCPF(
            this.dadosContribuinte.cadastroNacional
          );
        } else {
          this.dadosContribuinte.cadastroNacional = formatador.formataCNPJ(
            this.dadosContribuinte.cadastroNacional
          );
        }
        this.dadosContribuinte.nomeContribuinte =
        this.$store.getters.userInfo.name.toUpperCase();         
      } else {
        this.dadosContribuinte.cadastroNacional = "";
        this.dadosContribuinte.nomeContribuinte = "";
        this.preencheCpfCnpjOK = false;
      }
    },

    abrirModalPagamentoAVistaSeNecessario: function (referencia) {
      if (this.calculos.TLISTAURLGUIA) this.$refs[referencia].show();
    },

    mostrarModalParcelamento: function () {
      if (
        this.calculos.OPCOES_PARCTO_CESSAO &&
        this.calculos.OPCOES_PARCTO_DEMAIS
      )
        this.$refs["modal-confirmar-parcelamento"].show();
      else {
        if (this.calculos.OPCOES_PARCTO_CESSAO)
          this.abrirModalParcelamentoSeNecessario("cessao");
        else this.abrirModalParcelamentoSeNecessario("demais");
      }
    },

    abrirModalParcelamentoSeNecessario: function (tipoLancamento) {
      this.fecharModal("dialog-confirmar-parcelamento");

      if (tipoLancamento === "cessao") {
        this.mostrarCessao = true;
        this.mostrarDemais = false;
        this.$refs["modal-parcelamento"].show();
      }

      if (tipoLancamento === "demais") {
        this.mostrarCessao = false;
        this.mostrarDemais = true;
        this.$refs["modal-parcelamento"].show();
      }
    },

    abrirModalParcelamento: function (opcao) {
      this.opcaoParctoSelecionada = opcao;
      if (opcao.LISTA_OPCAO_PARCTO) {
        opcao.LISTA_OPCAO_PARCTO.map((calculo) => {
          this.listaOpcoesParcelamentoInternas.push({
            text: `Entrada de ${this.formatCurrency(
              calculo.AVLRDEPOSITOINICIAL
            )} + ${calculo.AQTDPARCELA} parcela(s) de ${this.formatCurrency(
              calculo.AVLRPARCELA
            )} (Desconto de ${calculo.APERCDEPOSITOINICIAL}%)`,
            value: calculo,
            disabled: false,
            hidden: false,
          });
        });

        this.listaDemaisParcelamentos.unshift({
          text: "Clique aqui para selecionar uma opção de parcelamento",
          value: "",
          selected: true,
          disabled: true,
          hidden: true,
        });

        this.$refs["modal-parcelamento"].show();
      }
    },

    abrirDialogPagamentoAVista() {
      this.abrirModalPagamentoAVistaSeNecessario("modal-pagamento-a-vista");
    },

    buscarCNPJSRelacionados: async function () {
      const preferedUsername = this.$store.getters.userInfo.preferred_username;
      if (!preferedUsername) {
        return;
      }
      this.carregando = true;
      await this.$axios
        .get(
          `${this.$env.url_backend}${constantes.buscarCNPJRelacionados}?cpf=${preferedUsername}`
        )
        .then((response) => {
          this.cnpjsRelacionados =
            response.data.cnpjRelacionados.listaEstabelecimento.map(
              (estabelecimento) => {
                return {
                  text: `CNPJ: ${formatador.formataCNPJ(
                    estabelecimento.cnpj
                  )} - ${estabelecimento.nome}`,
                  value: estabelecimento.cnpj,
                  nome: estabelecimento.nome,
                  cnpj: formatador.formataCNPJ(estabelecimento.cnpj),
                  razao: estabelecimento.nome,
                };
              }
            );
          this.cnpjsRelacionadosTabela = this.cnpjsRelacionados.map((valor) => {
            return {
              cnpj: valor.cnpj,
              cnpj_limpo: valor.cnpj.replace(/\D/g, ""),
              nome: valor.nome,
              selecionado: false,
            };
          });
          this.cnpjsRelacionadosTabelaBkp = this.cnpjsRelacionadosTabela;
          this.carregando = false;
        })
        .catch((error) => {
          const mensagem = normalizaMensagemApi(error);
          console.log(mensagem);
          this.carregando = false;
        });
    },

    abrirDialogParcelamento: async function () {
      const lancamentos = this.lancamentosSelecionados.map(
        (lancamento) => lancamento.ID_LANCAMENTO
      );
      const agrupamentos = this.lancamentosSelecionados.map(
        (lancamento) => lancamento.AGRUPAMENTO
      );
      await this.$axios
        .post(this.$env.url_backend + constantes.retornaOpcoesParcto, {
          lancamentosSelecionados: lancamentos,
          agrupamentos: agrupamentos,
        })
        .then((response) => {
          const retorno = response.data;
          const opcoesParctoRetorno = retorno[0];
          this.opcoesParcto = opcoesParctoRetorno;
        })
        .catch((err) => {
          this.carregando = false;
          window.scrollTo(0, 0);
          const mensagem = normalizaMensagemApi(err);
          this.mensagemParcelamento.push(mensagem);
        });

      if (this.opcoesParcto === null)
        this.mensagemParcelamento.push(
          "Não foram encontradas opções de parcelamento."
        );
      else this.$refs["modal-selecao-parcelamento"].show();
    },

    fecharModal: function (referencia) {
      this.$refs[referencia].hide();
    },

    retirarMensagensTela: function () {
      this.mensagemSucesso = [];
      this.mensagemErro = [];
      this.mensagemLancamentos = [];
      this.mensagemParcelamento = [];
      this.mensagemEmissaoGuia = [];
      this.mensagemEmissaoGuiaSucesso = [];

      this.mensagemValidacaoCPFCNPJ = "";
      this.erroValidacaoCPFCNPJ = "";
      this.mensagemValidacaoIdentificador = "";
      this.erroValidacaoIdentificador = "";
      this.mensagemValidacaoParcelamento = "";
      this.erroValidacaoParcelamento = "";
      this.mensagemValidacaoCodigoParcelamento = "";
      this.erroValidacaoCodigoParcelamento = "";
      this.mensagemValidacaoPlacaVeiculo = "";
      this.erroValidacaoPlacaVeiculo = "";
      this.mensagemValidacaoLancamento = "";
      this.erroValidacaoLancamento = "";
    },

    desabilitarAba(titulo) {
      if (titulo === "all") {
        this.mostrarSelecaoDebitos = false;
        this.mostrarSelecaoDebitos = false;
        this.exibirFormaPagamento = false;
        this.exibirListaGuiaParcelar = false;
        this.exibirDebitos = false;
        this.verLancamentos = false;
        this.exibirListaGuia = false;
        this.exibirParcelamento = false;
      }

      if (titulo === "selecaoDebito") {
        this.mostrarSelecaoDebitos = false;
        this.mostrarSelecaoDebitos = false;
        this.exibirFormaPagamento = false;
        this.exibirListaGuiaParcelar = false;
        this.exibirDebitos = false;
        this.verLancamentos = false;
        this.exibirListaGuia = false;
        this.exibirParcelamento = false;
      }
      if (titulo === "selecaoLancamento") {
        this.limparSelecao = true;
        this.mostrarSelecaoDebitos = false;
        this.exibirFormaPagamento = false;
        this.exibirListaGuiaParcelar = false;
        this.exibirDebitos = false;
        this.verLancamentos = false;
        this.exibirListaGuia = false;
        this.exibirParcelamento = false;
      }
      if (titulo === "debitos") {
        this.exibirDebitos = false;
        this.exibirFormaPagamento = false;
        this.exibirListaGuiaParcelar = false;
        this.exibirListaGuia = false;
        this.exibirParcelamento = false;
      }
      if (titulo === "formaPagamento") {
        this.exibirFormaPagamento = false;
        this.exibirListaGuia = false;
        this.exibirListaGuiaParcelar = false;
        this.exibirParcelamento = false;
      }
      if (titulo === "opcoesParcelamento") {
        this.exibirListaGuiaParcelar = false;
        this.exibirParcelamento = false;
      }
    },

    selecionarNovosLanctos() {
      this.mostrarSemEncargosMoratorios = false;
      this.refazerAgrupamento = false;
      this.bloqueiaOpcao = false;
      this.mensagemErro = [];
      this.desabilitaBtnParcelar = false;
      this.habilitaSelecaoDebitos();
      this.posicionaPagina();
    },

    habilitaSelecaoDebitos() {

      const existeTransacaoITBI = this.orgaoCobranca.some(
        item => item.valor?.toUpperCase().includes('TRANSAÇÃO DE ITBI')
      );
      //// verifica se existe transacao de itbi na seleção ////
      if (existeTransacaoITBI && this.origemAcesso !== "GovBr" && this.origemAcesso !== "AD") {
          this.mensagemErro.push({ mensInicio: "Transações ITBI somente podem ser exibidas com acesso ao GOV.br", mensLink: "", mensFim: "" });
          window.scrollTo(0, 0);
          this.carregando = false;  
      } else {
            this.mensagemErroFormaPagto = [];
            this.mensagemErro = [];
            this.desabilitarAba("selecaoLancamento");
            this.exibirDebitos = true;
            this.mostrarSelecaoDebitos = false;
            this.exibirDebitosSelecionados = false;
            this.exibirFormaPagamento = false;
            this.verLancamentos = false;
            this.reinicializarSelecao = false;
            this.posicionaPagina();
        }  
    },

    fecharGuiasParcelar() {
      this.exibirListaGuiaParcelar = false;
      this.opcaoParcelaSelecionada = null;
    },

    pagarVista() {
      this.desconto.numeroProcesso = null;
      this.desconto.descontoSimples = null;
      this.desconto.descontoCorrecao = null;
      this.desconto.descontoJuros = null;
      this.desconto.descontoMulta = null;
      this.desconto.descontoSelic = null;
      this.desconto.geraDescontoInscrito = null;
      this.desconto.dataVencimento = null;

      this.mensagemErroFormaPagto = [];
      this.exibirListaGuia = false;
      this.exibirListaGuiaParcelar = false;
      this.exibirFormaPagamento = false;
      this.retornaCalculos();
      this.permiteConcederDesconto = false;
    },

    fecharGuiasAVista() {
      this.mensagemErro = []; 
      this.exibirListaGuia = false;
      this.exibirFormaPagamento = true;   
       this.posicionaPagina();
    },

    scrollParaElemento(idElemento) {
      const elementoTopo = document.getElementById(idElemento).offsetTop; // Posição do elemento em relação ao topo da página
      window.scrollTo({ top: elementoTopo, behavior: "smooth" }); // Faz o scroll até a posição do elemento
    },

    parcelar: async function () {
      this.mensagemAlertaFormaPagto = [];
      this.mensagemErroFormaPagto = [];
      if (this.permiteParcelar) {
        const agrupamentos = this.lancamentosSelecionados.map(
          (lancamento) => lancamento.AGRUPAMENTO
        );
        if (agrupamentos.includes(5))   /// transação de ITBI ///  
              this.abrirModal("dialog-aviso-parcelamento-itbi");
        this.retornaCalculosParcelar();
      } else {
        this.mensagemErroFormaPagto = [];
        this.mensagemErroFormaPagto.push(
          "Existe(m) débito(s) selecionado(s) que não permite(m) parcelar."
        );
        this.carregando = false;
      }
      this.permiteConcederDesconto = false;
    },

    selecionaOpcaoGuiaParcelado(valor) {
      this.habilitaBotaoSelecionarGuia = valor === null;
    },

    guiaPagamentoParcelado(idx) {
      const ind = this.btnSelecionados.findIndex((e) => e.id === idx);

      // se já foi clicado ( existe na lista), remove
      if (ind !== -1) {
        this.btnSelecionados = this.btnSelecionados.filter(
          (item) => item.id != idx
        );
      } // inclui ( clicado )
      else {
        this.btnSelecionados.push({ id: idx });
      }
    },

    retornaSelecaoDebitos() {
      this.novaPesquisa = "N";
      this.reinicializarSelecao = true;
      this.orgaoCobranca = [];
      this.refazerAgrupamento = true;
      this.mostrarSelecaoDebitos = true;
      this.exibirDebitos = false;
      this.exibirDebitosSelecionados = false;
      this.exibirFormaPagamento = false;
      this.verLancamentos = false;
    },

    mostrarDebitosSelecionados() {
      this.exibirFormaPagamento = false;
      this.verLancamentos = false;
      this.exibirDebitosSelecionados = true;
    },

    fecharDebitosSelecionados() {
      this.exibirDebitosSelecionados = false;
      this.verLancamentos = true;
      if (!this.permiteConcederDesconto) {
        this.exibirFormaPagamento = true;      
         this.posicionaPagina();
      }
    },

    onClose() {
      this.popoverShow = false;
      this.$refs.popover.$emit("close");
    },

    onOk() {
      this.onClose();
      //  verifica concessão de desconto //
      this.exibirDebitos = false;
      this.mostrarSemEncargosMoratorios = true;
      this.carregando = false;
    },

    ConverterData: function (val) {
      if (val !== null) {
        const datahora = val;
        let splitdatahora = datahora.split("  ");
        const data = splitdatahora[0];
        const hora = splitdatahora[1];
        const splitdata = data.split("/");
        const dia = splitdata[0];
        const mes = splitdata[1];
        const ano = splitdata[2];
        const novoFormato = ano + "-" + mes + "-" + dia + " " + hora;
        return novoFormato;
      } else return null;
    },

    concedeDesconto() {
      this.consisteCamposConcessao();
      if (this.mensagemErroConcessaoDesconto.length == 0) {
        this.desconto.numeroProcesso =
          this.processoConcessaoDesconto !== ""
            ? this.processoConcessaoDesconto.replace(/[^\d]+/g, "")
            : "";
        this.desconto.descontoSimples = this.simples !== "" ? this.simples : 0;
        this.desconto.descontoCorrecao =
          this.correcao !== "" ? this.correcao : 0;
        this.desconto.descontoJuros = this.juros !== "" ? this.juros : 0;
        this.desconto.descontoMulta = this.multa !== "" ? this.multa : 0;
        this.desconto.descontoSelic = this.selic !== "" ? this.selic : 0;
        this.desconto.geraDescontoInscrito =
          this.desconto.geraDescontoInscrito !== ""
            ? this.desconto.geraDescontoInscrito
            : null;
        this.desconto.dataVencimento = this.venctoConcessaoDesconto;
        this.mostrarSemEncargosMoratorios = false;
        this.mensagemErroFormaPagto = [];
        this.exibirListaGuia = false;
        this.exibirListaGuiaParcelar = false;
        this.exibirFormaPagamento = false;
        this.concedeuDesconto = true;
        this.retornaCalculos();
      }
    },

    continuaSemDesconto() {
      this.opcaoAvistaOuParcelado();
    },

    formataData: function (date) {
      let d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },

    async verificaPerfilConcessaoDesconto() {
      this.fecharModal("modal-confirmar-selecao");
      this.mensagemErroConcessaoDesconto = [];
      this.mensagemValidacaoProcesso = "";
      this.concedeuDesconto = false;
      this.juros = "";
      this.multa = "";
      this.correcao = "";
      this.selic = "";
      this.simples = "";
      this.processoConcessaoDesconto = "";
      //  verifica perfil para concessão de desconto //
      if (this.origemAcesso == "AD") {
        if (!this.permiteConcederDesconto) {
            this.permiteConcederDesconto = this.permissaoAcesso;         
        }
      }
      this.exibirDebitos = false;
      // atualiza lancamentos selecionados //
      this.debitosSelecionados = this.lancamentosSelecionados;
      //
      this.mensagemAlertaFormaPagto = [];
      this.mensagemErroFormaPagto = [];
      if (this.permiteConcederDesconto) {
        //

        await this.$axios
          .post(this.$env.url_backend + constantes.retornaUltimaDataUtilMes, {})
          .then((response) => {
            const retorno = response.data;
            this.venctoConcessaoDesconto = retorno;
          })
          .catch(() => {
            this.permiteConcederDesconto = false;
          });
        //
        this.mostrarSemEncargosMoratorios = true;   
         this.posicionaPagina();        
      } else {
        this.opcaoAvistaOuParcelado();
      }
      this.carregando = false;
    },

    contemTributoDescricao(lista, tributoDescricao) {
      return lista.some(
        (item) => item.DESCRICAO_LANCAMENTO === tributoDescricao
      );
    },

    async opcaoAvistaOuParcelado() {
      this.verLancamentos = true;
      this.exibirDebitos = false;
      this.mostrarSemEncargosMoratorios = false;
      this.exibirFormaPagamento = true;    
      const temIssqnFonteRetido = false;
       this.posicionaPagina();
      if (this.permiteParcelar) {
        // verifica sem tem issqn fonte - retido na seleção pois não permite parcelar
        const temIssqnFonteRetido = this.contemTributoDescricao(
          this.debitosSelecionados,
          "ISSQN FONTE - RETIDO"
        );
        this.permiteParcelar = !temIssqnFonteRetido;
      }
      if (!this.permiteParcelar) {
        // nao permite parcelar, emite guia direto
        if (temIssqnFonteRetido)
          this.mensagemAlertaFormaPagto.push(
            `Atenção: O parcelamento de ISSQN-Fonte Retido não inscrito em
                    Dívida Ativa é vedado por lei, nos termos do art. 2º, p.u., I da
                    Lei Municipal nº 10.082/2011.`
          );
        this.pagarVista();
        this.exibirDebitosSelecionados = false;
        this.exibirFormaPagamento = false;
      }
      this.carregando = false;
    },

    montaAgrupamento: function (lista) {
      let agrupamentos = [];
      lista.map(function (lancamento) {
        agrupamentos.push({
          nome: lancamento.DESCRICAO,
          tooltip: lancamento.TOOLTIP,
          selecionado: false,
          valor: lancamento.VALOR || null,
          subitems:
            lancamento.LISTA_NIVEL2?.map(function (subnivel) {
              return {
                valor: `${lancamento.DESCRICAO}.${subnivel.DESCRICAO}`,
                selecionado: false,
                ALANCAMENTOS: subnivel.ALANCAMENTOS,
                qtdlanctos: subnivel.AQTDLANCTOS,
                valoravista: subnivel.AVALORAVISTA,
                valordebito: subnivel.AVALORDEBITO,
                valordesconto: subnivel.AVALORDESCONTO,
                nome: subnivel.DESCRICAO,
                aTooltip: subnivel.ATOOLTIP,
              };
            }) || null,
        });
      });

      return agrupamentos;
    },

    montalistaDramParcelamento: function (lista) {
      let listaArr = [];
      lista.map(function (dados) {
        listaArr.push({
          dataVencimento: dados.dataVencimento,
          DESCRICAO: dados.DESCRICAO,
          IDGUIA: dados.IDGUIA,
          NUMEROGUIA: dados.NUMEROGUIA,
          URLEMISSAO: dados.URLEMISSAO,
          URLRELACAO: dados.URLRELACAO,
          VALORDESCONTO: dados.VALORDESCONTO,
          VALORTOTAL: dados.VALORTOTAL,
          tipo: dados.IDGUIA == null ? "RELAÇÃO" : "DRAM",
        });
      });
      return listaArr;
    },

    retornoNumeroCorrespondente: function (val) {
      let letra = val.toUpperCase();
      if (letra === " ") return 0;
      else if (letra == "A" || letra == "J") return 1;
      else if (letra == "B" || letra == "K" || letra == "S") return 2;
      else if (letra == "C" || letra == "L" || letra == "T") return 3;
      else if (letra == "D" || letra == "M" || letra == "U") return 4;
      else if (letra == "E" || letra == "N" || letra == "V") return 5;
      else if (letra == "F" || letra == "O" || letra == "W") return 6;
      else if (letra == "G" || letra == "P" || letra == "X") return 7;
      else if (letra == "H" || letra == "Q" || letra == "Y") return 8;
      else if (letra == "I" || letra == "R" || letra == "Z") return 9;
      else return parseInt(letra);
    },

    validarIPTU: function (iptu) {
      iptu = iptu.replace(/[^\d \w]+/g, "").trim();
      if (iptu.length !== 15) return false;

      iptu = iptu.split("");
      const valores = [3, 2, 7, 6, 5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
      const posicoes = [6, 10, 11];

      let soma = 0;

      for (let index = 0; index < valores.length; index++) {
        let digito = iptu[index];

        if (posicoes.includes(index)) {
          soma += this.retornoNumeroCorrespondente(digito) * valores[index];
        } else {
          soma += digito * valores[index];
        }
      }
      const resto = soma % 11;
      let ultimoDigito = "";
      if (resto === 0) {
        ultimoDigito = "X";
      } else if (resto === 1) {
        ultimoDigito = "0";
      } else {
        ultimoDigito = 11 - resto;
      }

      return iptu[14] === ultimoDigito.toString();
    },

    validarInscricaoMunicipal: function (inscricaoMunicipal) {   
      inscricaoMunicipal = inscricaoMunicipal.replace(/[^\dxX]+/g, "");
      const sequencial = [3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
      let identificadorSemDigitoVerificador = "";
      let soma = 0;
      if (inscricaoMunicipal.length < 10)
        identificadorSemDigitoVerificador = inscricaoMunicipal
          .substring(0, 9)
          .padStart(10, "0");
      else if (inscricaoMunicipal.length === 10)
        if (inscricaoMunicipal.substring(0, 1) === "0")
          identificadorSemDigitoVerificador = inscricaoMunicipal
            .substring(1, 9)
            .padStart(10, "0");
        else if (Number(inscricaoMunicipal.substring(11, 1)))
          identificadorSemDigitoVerificador = inscricaoMunicipal;
        else
          identificadorSemDigitoVerificador = inscricaoMunicipal
            .substring(0, 9)
            .padStart(10, "0");
      else
        identificadorSemDigitoVerificador = inscricaoMunicipal
          .padStart(11, "0")
          .substring(0, 10);
      for (let i = 0; i < identificadorSemDigitoVerificador.length; i++)
        soma += Number(identificadorSemDigitoVerificador[i] * sequencial[i]);

      let resto = soma % 11;

      inscricaoMunicipal = inscricaoMunicipal.padStart(10, "0");
      const digitoVerificador =
        resto === 0 ? "0" : resto === 1 ? "X" : 11 - resto;
      identificadorSemDigitoVerificador += digitoVerificador;
      return inscricaoMunicipal === identificadorSemDigitoVerificador;
    },

    montaAgrupamentoParcto: function (lista) {
      let agrupamentos = [];
      lista.map(function (lancamento) {
        agrupamentos.push({
          descricao_grupo: lancamento.DESCRICAO_GRUPO,
          lista_lancamento: lancamento.LISTA_LANCAMENTO, ///idLancamentos,
          lista_agrupamento: lancamento.LISTA_AGRUPAMENTO, ///idAgrupamentos,
          lista_codigo_lancamento: lancamento.LISTA_CODIGO_LANCAMENTO,
          lista_lancamento_agrupamento: lancamento.LISTA_LANCAMENTO,
          selecionado: null,
          urlGuia: null,
          urlRelatorio: null,
          emitido: false,
          lista_opcao_parcto:
            lancamento.LISTA_OPCAO_PARCTO?.map(function (subnivel) {
              return {
                APercDepositoInicial: subnivel.APERCDEPOSITOINICIAL,
                AVlrDepositoInicial: subnivel.AVLRDEPOSITOINICIAL,
                AQtdParcela: subnivel.AQTDPARCELA,
                AQtdParcelaHonorario: subnivel.AQTDPARCELAHONORARIO,
                AVlrParcela: subnivel.AVLRPARCELA,
                AVlrParcelaHonorario: subnivel.AVLRPARCELAHONORARIO,
                AVlrdesconto: subnivel.AVLRDESCONTO,
                AIdTipoParcelamento: subnivel.AIDTIPOPARCELAMENTO,
                AIdRegraParcelamento: subnivel.AIDREGRAPARCELAMENTO,
                AIdFaixasRegraParcelamento: subnivel.AIDFAIXASREGRAPARCELAMENTO,
                adescricao: subnivel.ADESCRICAO,
              };
            }) || null,
        });
      });
      return agrupamentos;
    },

    toggleAll(checked) {
      this.selected = checked ? this.orgaoCobranca.slice() : [];
    },

    verificaLinkMens: function (valor) {
      let mensagem = {
        mensInicio: "",
        mensLink: "",
        mensFim: "",
      };
      if (valor.indexOf("www") >= 0 || valor.indexOf("http") >= 0) {
        let posicaoInicialPreLink = 0;
        posicaoInicialPreLink = valor.indexOf("www"); // procura por www
        if (posicaoInicialPreLink < 0) {
          // não encontrou
          posicaoInicialPreLink = valor.indexOf("http"); // procura por http
        }
        if (posicaoInicialPreLink >= 0) {
          let valorStr = valor.substring(posicaoInicialPreLink); // retorna o substring a partir da posicaoInicialPreLink
          if (valorStr != "") {
            let palavras = valorStr.split(" "); // divide o valorStr em palavras
            mensagem.mensLink = palavras[0];
          }
        } else {
          posicaoInicialPreLink = valor.length;
        }
        mensagem.mensInicio = valor.substring(0, posicaoInicialPreLink);

        mensagem.mensFim = valor.substring(
          posicaoInicialPreLink + mensagem.mensLink.length
        );
      } else {
        mensagem.mensInicio = valor;
      }
      return mensagem;
    },

    handleListaCnpjRelacionados(values) {
      this.listaCnpjRelacionados = values;
    },

    handleCnpjTabelaSelecionado(values) {
      if (values.dadosEstabelecimentoSelecionado.length == 0) {
        return;
      }
      const codigoNacional =
        values.dadosEstabelecimentoSelecionado.codigoNacional;
      const razaoSocial = values.dadosEstabelecimentoSelecionado.razaoSocial;
      this.cnpjRelacionadoFoiSelecionado = false;
      this.desabilitaNome = false;
      this.desabilitaIdentificador = false;
      this.limparCampos();
      // aguarda um momento para garantir que o DOM foi atualizado
      this.$nextTick(() => {
        this.cnpjRelacionadoFoiSelecionado = true;
        this.desabilitaNome = true;
        this.montaSelecionado(codigoNacional, razaoSocial);
      });
      this.exibirEmpresaRelacionada = true;
      this.mostrarListagemCnpj = false;
    },
    async filtrarLancamentoParametro() {
      // encontrar agrupamento que contém o lançamento com o código correspondente
      // [{LISTA_NIVEL2:[{ALANCAMENTOS:[{CODIGO_LANCAMENTO}]}]}]
      const { listaIndex, subnivelIndex } =
        this.encontrarLancamentoEmAgrupamentos(this.dadosContribuinte.identificador); 
      if (listaIndex === null || subnivelIndex === null) {
        this.carregando = false;
        return;
      }
      const lista = this.listaAgrupamentos[listaIndex];
      const subnivel = lista && lista.LISTA_NIVEL2 && lista.LISTA_NIVEL2.length ? lista.LISTA_NIVEL2[subnivelIndex] : null;
      if (!subnivel) {
        this.carregando = false;
        return;
      }
      this.getDebitosSelecionados(lista.LISTA_NIVEL2);
      this.habilitaSelecaoDebitos();
      this.carregando = false;
    },
    encontrarLancamentoEmAgrupamentos(codigoLancamento) {
      let listaIndex = null;
      let subnivelIndex = null;
      for (let i = 0; i < this.listaAgrupamentos.length; i++) {
        const agrupamento = this.listaAgrupamentos[i];
        if (agrupamento.LISTA_NIVEL2) {
          for (let j = 0; j < agrupamento.LISTA_NIVEL2.length; j++) {
            const subnivel = agrupamento.LISTA_NIVEL2[j];
            if (subnivel.ALANCAMENTOS) {
              const lancamentoIndexEncontrado = subnivel.ALANCAMENTOS.findIndex(
                (lancamento) =>
                  lancamento.CODIGO_LANCAMENTO ===
                  codigoLancamento
              );
              if (lancamentoIndexEncontrado !== -1) {
                listaIndex = i;
                subnivelIndex = j;
                break;
              }
            }
          }
        }
        if (listaIndex !== null) {
          break;
        }
      }
      return { listaIndex, subnivelIndex };
    },
    async verificarPermissaoEspecial() {
      if (this.origemAcesso !== "AD") {
        this.permissaoAcesso = false;
        this.acessoMinisterioPublico = false;
        return;
      }
      try {
        const { data } = await this.$axios.post(
          this.$env.url_backend + constantes.possuiPermissaoEspecial,
          {
            usecase: "USC.12.911",
            usuario: this.userName.toUpperCase(),
          }
        );

        this.permissaoAcesso = data;
      } catch (e) {
        this.mensagemErro.push(
          "PÁGINA EM MANUTENÇÃO, FAVOR ACESSAR MAIS TARDE."
        );
        window.scrollTo(0, 0);
      }      
      /// sdm 4909857 - acesso ao Ministerio Publico
      try {
        const { data } = await this.$axios.post(
          this.$env.url_backend + constantes.possuiPermissaoEspecial,
          {
            usecase: "USC.12.912",
            usuario: this.userName.toUpperCase(),
          }
        );

        this.acessoMinisterioPublico = data;
      } catch (e) {
        this.mensagemErro.push(
          "PÁGINA EM MANUTENÇÃO, FAVOR ACESSAR MAIS TARDE."
        );
        window.scrollTo(0, 0);
      }
      ///
    },
    async autoPesquisarPorCodigoLancamento() {
      let codigoLancamento = this.$route?.query?.codigoLancamento;
      if (!codigoLancamento) return;
      if (codigoLancamento.length !== 14) return;
      if (!/^[a-zA-Z0-9\-_]+$/.test(codigoLancamento)) return;
      codigoLancamento = codigoLancamento.toUpperCase();

      // se não tiber logado (origemAcesso), aguarda uns segundos antes de seguir, para garantir que as informações do usuário estejam disponíveis
      if (!this.origemAcesso) {
        await new Promise((resolve) => setTimeout(resolve, 4000));
      }

      this.codigoLancamentoParam = codigoLancamento;
      this.dadosContribuinte.tipoIdentificador = 17;
      this.dadosContribuinte.identificador = codigoLancamento;

      await this.pesquisar(async () => {
        this.carregando = true;

        // aguarda um momento para garantir que o DOM foi atualizado e os dados foram carregados antes de tentar filtrar os lançamentos
        await new Promise((resolve) => setTimeout(resolve, 1000));

        // o código de lançamento foi removido por alguma chegagem no pesquisar
        // então não tem como filtrar os lançamentos
        if (!this.codigoLancamentoParam) {
          this.carregando = false;
          return;
        }

        await this.habilitaSelecaoDebitos();

        this.dadosContribuinte.tipoIdentificador = 17;
        this.dadosContribuinte.identificador = codigoLancamento;
        this.exibirEmpresaRelacionada = false;

        if (this.informacaoContribuinte.nome) {
          this.exibirEmpresaRelacionada = true;
          this.cnpj.nome = this.informacaoContribuinte.nome || "";
          this.cnpj.valor = this.informacaoContribuinte.cadastroNacional || "";
        }

        this.carregando = false;
      });
    },

    async handleCarregaTiposIdentificadores() {
      return carregaTiposIdentificadores().then((opcoes) => {
        this.opcoesIdentificador = (opcoes || []).filter((opcao) => {
          // Se a origem de acesso for "GovBr", filtra para excluir o tipo de identificador com valor 4 (CNPJ)
          if (this.origemAcesso === "GovBr") {
            return opcao.value !== 4; // cnpj
          }
          // Se a origem de acesso não for "AD", filtra para excluir o tipo de identificador com valor 16 (código de lançamento)
          if (this.origemAcesso !== "AD") {
            return opcao.value !== 16; // código de lançamento
          }
          // Caso contrário, inclui todas as opções de identificador
          return true;
        });
      }).catch((err) => {
        this.opcoesIdentificador = [];
        const mensagem = normalizaMensagemApi(err);
        this.mensagemErro.push({
          mensInicio: mensagem,
          mensLink: "",
          mensFim: "",
        });
        window.scrollTo(0, 0);
      });
    }
  },

  watch: {
    selected(newValue) {
      // Handle changes in individual flavour checkboxes
      if (newValue.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newValue.length === this.orgaoCobranca.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    },

    "dadosContribuinte.tipoIdentificador" (newValue) {
       if (newValue && 
           (this.origemAcesso === "GovBr" || this.origemAcesso === "AD") &&
           this.dadosContribuinte.cadastroNacional.length >= 0) {
              //  this.pesquisando = false;
               this.preenchePlaceHolderIdentificador();
       }
    },

    processoConcessaoDesconto(newValue) {
      if (newValue.length === 0) {
        this.mensagemValidacaoProcesso = "";
        this.processoValido = false;
      }
    }
  },

  computed: {
      rows() {
        return this.items.length;
      },
      pesquisando(){
        return (
             this.mostrarSelecaoDebitos        ||
             this.exibirDebitos                ||
             this.verLancamentos               ||
             this.exibirDebitosSelecionados    ||
             this.mostrarSemEncargosMoratorios ||
             this.exibirFormaPagamento         ||
             this.exibirListaGuia              ||
             this.exibirListaGuiaParcelar      ||
             this.exibirParcelamento          
              // || this.mensagemErro.length > 0
           );  
      }
  },

  async beforeMount() {
    this.userName = this.$store.getters.userInfo.preferred_username;
    this.origemAcesso = this.$store.getters.userInfo.origem;
    
    if (this.origemAcesso === "GovBr") {
      this.dadosContribuinte.cadastroNacional = this.userName;
      this.dadosContribuinte.nomeContribuinte =
                this.$store.getters.userInfo.name.toUpperCase();
      this.preencheCpfCnpjOK = true;
      this.habilitaDesabilitaCnpjCpf = true;
      await this.buscarCNPJSRelacionados();
    }

    // se tiver logado (origemAcesso), aguarda uns segundos antes de seguir
    if (!this.origemAcesso) {
      await new Promise((resolve) => setTimeout(resolve, 1000));
    }

    await this.autoPesquisarPorCodigoLancamento();
  },

  created() {
    this.cabecalhoLancamento = this.cabecalhoLancamento.map((atributo) => {
      return {
        key: atributo.key,
        label: atributo.label,
        formatter: atributo.formatter,
        sortable: atributo.sortable,
      };
    });

    this.cabecalhoEmissaoGuia = this.cabecalhoEmissaoGuia.map((atributo) => {
      return {
        key: atributo.key,
        label: atributo.label,
        formatter: atributo.formatter,
        sortable: atributo.sortable,
      };
    });
  },

  async mounted() {
    this.$nextTick(() => {
      this.focusInput(this.origemAcesso === "AD" ? "cpfCnpj" : "opcaoIdentificador");
    });
    await this.verificarPermissaoEspecial();
    await this.handleCarregaTiposIdentificadores();
  },
};
</script>

<style lang="css" scoped>
.linha-separadora {
  border-top: 1px solid #ccc;
  width: 100%;
}

.container {
  min-width: 90%;
  max-width: 90%;
}

::v-deep .small-modal .modal-dialog {
  width: 30%;
  max-width: 50%;
}

::v-deep .modal-dialog {
  width: 95%;
  max-width: 100%;
}

hr {
  border-color: #aaa;
  box-sizing: border-box;
  width: 100%;
}

.tooltip .tooltiptext {
  width: 20px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.inner-btn.btn_tam {
  width: 10px;
  height: 20px;
}

.botao {
  width: 150px;
  height: 80px;
}

.inner-btn {
  position: absolute;
  width: 10px;
  font-weight: 550;
  border: none;
  background-color: transparent;
  line-height: 35px;
  left: calc(100% - 30px);
  z-index: 99999;
}

.inner-btn:hover {
  color: blue;
}
</style>
